(function () {
    angular.module('ui2.0Service').factory('showPageService', ['entityFactory', 'dataManipulationService', 'formService','contractTemplateService' ,'filterService', '$http', '$rootScope', '$timeout', '$document', '$compile', '$uibModal',
        function (entityFactory, dataManipulationService, formService, contractTemplateService, filterService, $http, $rootScope, $timeout, $document, $compile, $modal) {

        /* **********************************************************************************************************
         ****************************************** showPageService *************************************************
         ************* NOTE : FUNCTIONS WRITTEN IN THIS SERVICE WERE PREVIOUSLY WRITTEN IN CONTRACTCONTROLLER.JS ****
         ***********************************************************************************************************/

        /************ Functions exposed from showPageService , to be used in other modules *************/
        var docTreeFilterDataJson = {};
        var filterQueryParam = {};
        var filterData = {};
        var retObj = {showDocTreeFilterPanel:false,docTreeFilterRendered:false,showDocTreeFilterBtn:true};
        var self = this;
        function isActiveUploadButton(btn) {
            return btn && btn.active && btn.name && btn.properties && btn.properties.buttonType === 'upload';
        }

        function snapshotActiveUploadButtons() {
            var activeMap = {};
            var mapper = formService.buttonMapper;
            if (!mapper || typeof mapper !== 'object') return activeMap;
            Object.keys(mapper).forEach(function (fId) {
                var buttons = mapper[fId];
                if (!Array.isArray(buttons)) return;
                buttons.filter(isActiveUploadButton).forEach(function (btn) {
                    if (!activeMap[fId]) activeMap[fId] = {};
                    activeMap[fId][btn.name] = true;
                });
            });
            return activeMap;
        }

        function restoreActiveUploadButtons(activeMap) {
            Object.keys(activeMap).forEach(function (fId) {
                var buttons = formService.buttonMapper[fId];
                if (!Array.isArray(buttons)) return;
                buttons.filter(function (btn) {
                    return btn && btn.name && activeMap[fId][btn.name];
                }).forEach(function (btn) {
                    btn.active = true;
                });
            });
        }

        var privateMethods = {
            removeParamFromUrl: (paramToRemove) => {
                const qParamVar = "?",
                    href = window.location.href,
                    [url, qParams] = [...href.split(qParamVar)];

                let params = qParams.split('&'),
                    finalUrl = url;
                if (params.length > 1) {
                    const removeParamFromIndex = params.findIndex(p => p.indexOf(paramToRemove) > -1);
                    params.splice(removeParamFromIndex, 1);
                    finalUrl += qParamVar + params.join('&');
                }

                history.replaceState(null, null, finalUrl);
            }
        };
        return {
            fetchTemplateCreateSubDD: fetchTemplateCreateSubDD,
            loadTemplateContent: loadTemplateContent,
            getGFieldModel: getGFieldModel,
            checkForApiAndGetData: checkForApiAndGetData,
            getModelfromString: getModelfromString,
            setValidity: setValidity,
            getFormValidity: getFormValidity,
            scrollToElem: scrollToElem,
            setValueOfenableAddComment: setValueOfenableAddComment,
            preventLabelClick: preventLabelClick,
            renderActionButtons: renderActionButtons,
            renderCreateLinkOptions: renderCreateLinks,
            setPositionOfDatepicker: setPositionOfDatepicker,
            setLocalListingSwitchData: setLocalListingSwitchData,
            getLocalListingURL: getLocalListingURL,
            isLocalListingEnabled: isLocalListingEnabled,
            setLocalListingHistory: setLocalListingHistory,
            getLocalListingBackURL: getLocalListingBackURL,
            isLocalListingPermissible: isLocalListingPermissible,
            assignValuesBasedOnActions: assignValuesBasedOnActions,
            checkCDRimportEnability: checkCDRimportEnability,
            initDocTreeFilters: initDocTreeFilters,
            renderDocTreeFilters: renderDocTreeFilters,
            toggleDocTreeFilterPanel: toggleDocTreeFilterPanel,
            applyFilterOnDocTree: applyFilterOnDocTree,
            resetFavourites:resetFavourites,
            setViewType:setViewType,
            createAeDocPropContainer:createAeDocPropContainer,
            createStrategyCloneContainer:createStrategyCloneContainer,
            docTreeDatePickerFunctions:docTreeDatePickerFunctions,
            snapshotActiveUploadButtons: snapshotActiveUploadButtons,
            restoreActiveUploadButtons: restoreActiveUploadButtons,
            renderPageInbound:renderPageInbound,
            scrollToErrorElem:scrollToErrorElem,
            changeErrorCount: changeErrorCount,
            removeDynamicTableErrObj: removeDynamicTableErrObj,
            retObj : retObj,
            emptyDependentField:emptyDependentField,
            getDataForDependentField:getDataForDependentField,
            getsourceId:getsourceId,
            deleteInvoiceCopy:deleteInvoiceCopy,
            loadInvoiceContent:loadInvoiceContent,
            activateTabOnLoad: activateTabOnLoad,
            showInvoiceCopyToolTip: showInvoiceCopyToolTip,
            showToolTip: showToolTip,
            mapLayout: mapLayout,
            prepareCompareModalData: prepareCompareModalData,
            openModalInCompareMode: openModalInCompareMode,
            loadCommPanelPreference: loadCommPanelPreference,
            showCommPanelNotification: showCommPanelNotification,
            openInheritModal: openInheritModal,
            openMoveToTreeModal: openMoveToTreeModal,
            openSendToSigModal: openSendToSigModal,
            downloadCommentData: downloadCommentData,
            downloadCommentAttachmentData: downloadCommentAttachmentData,
            getFeedsData: getFeedsData,
            openSpecifiedTab:openSpecifiedTab,
            updateCommentAndFeeds:updateCommentAndFeeds,
            manageTimeLineCommentOldScope:manageTimeLineCommentOldScope,
            loadContractToCdrTableData : loadContractToCdrTableData,
            getInsightFilters:getInsightFilters,
            bulkAttendanceUpdateGB: bulkAttendanceUpdateGB,
            setPreviewTab : setPreviewTab,
            getDocuSignToSirionMapper: getDocuSignToSirionMapper,
            getPlaceholderInFormat: getPlaceholderInFormat,
            getHighlightId: getHighlightId,
            getOnlyFieldIds: getOnlyFieldIds,
            fetchFeedsData: fetchFeedsData,
            openLinkClauseModal: openLinkClauseModal,
            getFeedCardList: getFeedCardList,
            updateRightSectionState: updateRightSectionState,
            openRightSection: openRightSection,
            openSecondLevelDD: openSecondLevelDD,
            refreshRoute: refreshRoute,
            suggestRefresh:suggestRefresh,
            startPolling: startPolling,
            getWfSelectionList: getWfSelectionList,
            handleRedirectionFromShortCodeId: handleRedirectionFromShortCodeId,
            removeUnusedGroupInfo: removeUnusedGroupInfo,
            logAjaxCall: logAjaxCall,
            resetSuggestRefreshPolling: resetSuggestRefreshPolling,
            getCurrentPage: getCurrentPage,
            clearSuggRefreshCallAndDeleteScope: clearSuggRefreshCallAndDeleteScope,
            toggleExpectedLanguage: toggleExpectedLanguage,
            highlightCoordinatesInIframe: highlightCoordinatesInIFrame,
            shouldGenerateDraft: shouldGenerateDraft,
            getSurveyQueryParams: getSurveyQueryParams,
            getContractDownloadPermission: getContractDownloadPermission
        }

            function clearSuggRefreshCallAndDeleteScope(notDeleteScope) {
                if($rootScope.suggestRefreshScope?.polling) {
                    clearInterval($rootScope.suggestRefreshScope.polling);
                    delete $rootScope.suggestRefreshScope.polling
                }
                !notDeleteScope && (delete $rootScope.suggestRefreshScope);
            }

            function getCurrentPage() {
                const scope = $('ng-view').scope();
                return scope?.pageType;
            }

            function resetSuggestRefreshPolling() {
                setTimeout(() => $rootScope.firstPolling = true,100)
            }
            function logAjaxCall(ajaxCall) {
                if(angular.isUndefined($rootScope.ajaxCallsInProgress)) {
                    $rootScope.ajaxCallsInProgress = [];
                }
                $rootScope.ajaxCallsInProgress.push(ajaxCall);
            }
            function startPolling($scope){
                // func to call suggestRefresh every 5 sec for showpage to be updated with latest data
                if ($rootScope.suggestRefreshScope?.continuePolling){
                    let timer = 5 * 1000;
                    $rootScope.suggestRefreshScope.polling = setInterval(function(){
                        suggestRefresh($scope);
                    },timer);
                }
            }
            function suggestRefresh($scope){
                // func. call to check if any new data is updated on showpage. Currently valid for CDR showpage entity only.
                if( $scope.data.entityTypeId.values !== 160 || !$scope.suggestRefreshAllowed) {
                    if($rootScope.suggestRefreshScope) {
                        delete $rootScope.suggestRefreshScope;
                    }
                    return;
                };
                const currPage = getCurrentPage();
                $rootScope.suggestRefreshScope = _.has($rootScope,'suggestRefreshScope')  ? $rootScope.suggestRefreshScope : {
                    continuePolling: true,
                    firstPolling: true,
                    prevPollingData: {},
                    polling: null,
                    currentPage:currPage,
                    prevPage: currPage
                };
                const entityId = $rootScope.data?.id?.values,
                    entityTypeId = $rootScope.data?.entityTypeId?.values;

                if(!entityId) {
                    /*
                    * Note: If no entityId is present in the data then it means it is a craete/clone page.
                    *       Need to clear suggestRefreshScope as it might be from older scope
                    * */
                    clearSuggRefreshCallAndDeleteScope();
                }
               if(entityId && entityTypeId ) {
                  let url = addtStamp(`/suggestRefresh/getAuditLog/${entityTypeId}/${entityId}`, true);
                  $http.get(url).then(function(res) {
                      let data = res.data.auditlogid;
                      let autotask = res.data.autotask;
                      let userid = res.data.userid;

                      const makeRefreshBannerVisible = () => {
                          $rootScope.suggestRefreshScope.continuePolling = false;
                          delete $rootScope.suggestRefreshScope.prevPollingData;
                          clearSuggRefreshCallAndDeleteScope(true);
                      }

                      $rootScope.suggestRefreshScope.currentPage = getCurrentPage();
                      const {currentPage,prevPage} = $rootScope.suggestRefreshScope;
                      if(currentPage !== prevPage) {
                          $rootScope.suggestRefreshScope.prevPage = currentPage;
                          if(_.isEmpty($rootScope.suggestRefreshScope.prevPollingData)) {
                              $rootScope.suggestRefreshScope = {
                                  ...$rootScope.suggestRefreshScope,
                                  firstPolling: true,
                                  continuePolling: true
                              }
                          }
                      }

                      // just to update previous polling data so that it can be verified in later api calls.
                      if($rootScope.suggestRefreshScope?.firstPolling) {
                          $rootScope.suggestRefreshScope.prevPollingData = {prevCData:_.cloneDeep($scope.data),data:data};
                          $rootScope.suggestRefreshScope.firstPolling = false;
                          $rootScope.currentEntityId = entityId;
                          sessionStorage.setItem('currentEntityId',entityId);
                          startPolling($scope);
                      }
                      // if any new data is updated then suggest to refresh page and clear interval
                      else if($rootScope.suggestRefreshScope.prevPollingData?.data !== data && (window.currentUserId !== userid || autotask)){
                          makeRefreshBannerVisible();
                      }
                      else if(!$rootScope.suggestRefreshScope.polling){
                          startPolling($scope);
                      }

                      if($rootScope.showRefresh?.entityId == entityId && autotask) {
                          makeRefreshBannerVisible();
                          delete $rootScope.showRefresh;
                      }
                  }).catch(function (error){
                      console.log('error',error);
                  } );
               }
            }
            function refreshRoute($scope,$route,SirionUtils){
                // check if metadata is changed on edit page , then show a popup, warning the user that unsaved data in progress will be lost if the page is refreshed.
                let hasMetadataChanged = !_.isEqual($rootScope?.suggestRefreshScope?.prevPollingData?.prevCData,_.cloneDeep($scope.data));
                if($scope.pageType === 'edit' && hasMetadataChanged){
                    const args = {
                        popupType: 'confirm',
                        str: intl_msg[34746],
                        heading: "Alert",
                        yesCbFn: function () {
                            clearSuggRefreshCallAndDeleteScope();
                            $route.reload();
                        },
                        yesName: intl_msg[24184],
                        noCbFn : cancelString,
                        noName: intl_msg[23731]
                    }
                    SirionUtils.openSirionDialogs(args);
                }else if ($scope.showWorkspaceView && $scope.showListDataTableHeader){
                    $rootScope.suggestRefreshScope.continuePolling = true;
                    $rootScope.suggestRefreshScope.firstPolling = true;
                    let currentListingShowPage = $scope.feedsResponse?.entityId || $scope.workSpaceCurrentListUrl || $scope.clauseId
                    let currentListingIndex = $scope.workSpaceViewListData.findIndex(showpage => showpage.id.href.indexOf(currentListingShowPage) > -1 );
                    $scope.workSpaceViewLiClick($(".workSpaceListContent li.workspaceViewLi")[currentListingIndex]);
                }else {
                    clearSuggRefreshCallAndDeleteScope();
                    $route.reload();
                }
            }
        function getHighlightId() {
            return new Date().getTime() * parseInt(Math.random() * 1000);
        }
        function openSecondLevelDD(e){
            e.stopPropagation();
            if (angular.element(e.currentTarget).find('.sLevel-anchor').hasClass('active')) {
                angular.element(e.currentTarget).find('.sLevel').slideUp();
                angular.element(e.currentTarget).find('.sLevel-anchor').removeClass('active');
            } else {
                angular.element(e.currentTarget).find('.sLevel').first().slideDown();
                angular.element(e.currentTarget).find('.sLevel-anchor').first().addClass('active');
            }
        }
        function updateRightSectionState(funcCall, funcValue,selectedTab) {
            const generateEntityObj = () => {
                return {
                    tabs: [],
                    funcCall: 0
                }
            }
                // this function updates the localstorage containing 'isRighSectionActive';
            if (_.isUndefined(selectedTab) || selectedTab.type.includes('basic')) {
                selectedTab = 'General';
            } else {
                selectedTab = 'Others';
            }
            let isRightSecActive = JSON.parse(sessionStorage.getItem('isRightSectionActive')) || {
                [$rootScope.currentEntityId]: generateEntityObj()
            }
            if(!isRightSecActive[$rootScope.currentEntityId]) {
                isRightSecActive[$rootScope.currentEntityId] = generateEntityObj();
            }

            const rightSecObj = isRightSecActive[$rootScope.currentEntityId];
            let funcCallKey = funcCall === 0 ? 0 : funcValue;
            try {
                if (funcCallKey < 1 && rightSecObj.tabs.includes(selectedTab)) {
                    // check if selectedTab is in isRightSecActive.tabs
                    // if yes, remove it from isRightSecActive.tabs
                    // if closed on general tab. Close for all tabs
                    if (selectedTab == 'General') {
                        rightSecObj.tabs = [];
                        sessionStorage.setItem('isRightSectionActive', JSON.stringify(isRightSecActive));
                    } else {
                        rightSecObj.tabs.splice(rightSecObj.tabs.indexOf(selectedTab), 1);
                        sessionStorage.setItem('isRightSectionActive', JSON.stringify(isRightSecActive));
                    }
                } else if (!rightSecObj.tabs.includes(selectedTab) && funcCallKey > 0) {
                    // if no, then check if selectedTab is in isRightSecActive.tabs
                    // if not, then add it to isRightSecActive.tabs
                    selectedTab && rightSecObj.tabs.push(selectedTab);
                    sessionStorage.setItem('isRightSectionActive', JSON.stringify(isRightSecActive));
                }
                if(funcCall == "handleUploadSectionVisibility" && rightSecObj.tabs.includes('Others')) {
                    rightSecObj.tabs.splice(rightSecObj.tabs.indexOf('Others'), 1);
                    sessionStorage.setItem('isRightSectionActive', JSON.stringify(isRightSecActive));
                }
            } catch (e) {
                console.log(e);
            } finally {
                // update funcCall in isRightSecActive if not 0,-1
                if (funcCallKey > 0 || (funcCall == "setMiraDocRepoScope" && !funcValue)) {
                    rightSecObj.funcCall = {};
                    rightSecObj.funcCall[funcCall] = funcCallKey;
                    sessionStorage.setItem('isRightSectionActive', JSON.stringify(isRightSecActive));
                }
            }
        }

        function openRightSection(selectedTab,$scope) {
                // this function is used to open right section on close of left section [doc-tree/pdf-viewer...] using localStorage.
                
                if($scope.showPage2DataTransformationService?.returnObj?.viewerTabInfo?.length) {
                    return;
                }

                let localStorageObj = JSON.parse(sessionStorage.getItem('isRightSectionActive'));
                localStorageObj = localStorageObj && localStorageObj[$rootScope.currentEntityId];
                let activeTabs = localStorageObj && localStorageObj.tabs;
                let functionCall = localStorageObj && localStorageObj.funcCall;
                if (_.isUndefined(selectedTab) || selectedTab.type.includes('basic')) {
                    selectedTab = 'General';
                } else {
                    selectedTab = 'Others';
                }
                if ($scope.expandLeftSection && activeTabs && activeTabs.includes(selectedTab)) {
                    // if localstorage obj contains the selected tab
                    let funcCallKey = functionCall && Object.keys(functionCall)[0];
                    let funcCallValue = functionCall && functionCall[`${funcCallKey}`];
                    if(funcCallKey) {
                        if(funcCallKey=="setCommDataScope") {
                            $scope[funcCallKey](funcCallValue,false,$scope.showCommentPanelInRightSec);
                        }else $scope[funcCallKey](funcCallValue);
                    }
                } else if (!_.isEmpty(activeTabs) && !activeTabs.includes(selectedTab)) {
                    let funcCallKey = functionCall && Object.keys(functionCall)[0];
                    if(funcCallKey=="setCommDataScope") {
                        $scope[funcCallKey](-1,false,$scope.showCommentPanelInRightSec);
                    } else if(funcCallKey=="setMiraDocRepoScope") {
                        $scope[funcCallKey](false);
                    }
                    else $scope[funcCallKey](-1);
                }
            }

        function getPlaceholderInFormat (docs,placeholderTab,docId,stkHolderId ,sName,stkHolder,fromTemplate) {
            const getIndexOfDocumnet = (docId) => {
                let index = 0;
                docs.map((d,i)=>{
                    if(d.documentFileId == docId || d.documentId ==docId){
                        index  = i;
                    }
                })
                return index;
            }
            const docuSignToSirionMapper = this.getDocuSignToSirionMapper();
            const mappedValue= docuSignToSirionMapper[placeholderTab.tabType];
            let placeholder;
            if(!mappedValue) {
                placeholder = _.cloneDeep(placeholderTab);
                placeholder.stakeholder = stkHolder;
                placeholder.skipVisibilityInViewer = true;
            }else placeholder = {type : mappedValue.name , icon : mappedValue.icon , dataImg : '',stakeholder : stkHolder};

            let xPosition = parseFloat(placeholderTab.xpositionPercentage || placeholderTab.xPosition);
            const tabType = placeholderTab.tabType.toLowerCase();
            if(tabType == "text"){
                placeholder.TextAreaValue = placeholderTab.textTabValue || placeholderTab.value;
                fromTemplate && (xPosition += 2.6);
            }
            if(["company","title","text"].indexOf(tabType) > -1){
                if(placeholderTab.readOnly || placeholderTab.locked == "true"){
                    placeholder.RO = true
                }else if(placeholderTab.locked == "false" && placeholderTab.required == "false"){
                    placeholder.OF =  true
                    placeholder.RF = false
                } else placeholder.RF =  true
            }

            if( ["signhere","initialhere"].indexOf(tabType) > -1) {
                placeholder.OF = placeholderTab.optional == "true"
            }

            placeholder['highLightId'] = getHighlightId();
            placeholder['containers'] = [{
                dataImg : "" ,
                itemPlaced : mappedValue.name,
                pageno : placeholderTab.pageNumber,
                height : 0 ,
                width : 0,
                left : placeholderTab.xposition,
                top : placeholderTab.yposition ,
                sendTopValue : placeholderTab.ypositionPercentage,
                docID : placeholderTab.documentID,
                xPercentage :xPosition,
                yPercentage :placeholderTab.ypositionPercentage || placeholderTab.yPosition
            }];
            placeholder['cssProperties'] = {
                defaultFontSize : 14 ,
                height:22 ,
                top : 5 ,
                left : {},
                allWidth : {},
            };
            placeholder.byPassUiCalculation = true;
            let i = getIndexOfDocumnet(docId);
            if(!(docs[i]['placeHolder'])){
                docs[i]['placeHolder'] = [];
            }
            placeholder && docs[i]['placeHolder'].push(placeholder);
            const stakeholder ={id  : stkHolderId , name : sName  , Initials :  globalFunc.getUserInitials(sName)};
            if(!(docs[i]['stakeholder'])){
                docs[i]['stakeholder'] = [];
                docs[i]['stakeholder'].push(stakeholder);
            }else{
                let addStakeholder = true
                docs[i]['stakeholder'].forEach(s=>{
                    if(s.id == stkHolderId){
                        addStakeholder =false;
                    }
                })
                if(addStakeholder){
                    docs[i]['stakeholder'].push(stakeholder);
                }
            }
        }

        function getDocuSignToSirionMapper() {
            const docuSignToSirionMapper = {
                'signhere' : {name: "Signature",icon : 'icon-Initiate-Signature'},
                'company' : {name: "Company",icon : 'icon-Company'},
                'datesigned' :{name: "Date Signed",icon : 'icon-calendar'},
                'emailaddress':{name: "Email",icon : 'icon-Mass-Mails'},
                'fullname':{name: "Name",icon : 'icon-Profile'},
                'initialhere':{name: "Initial",icon : 'icon-Initials'},
                'text':{name: "Text",icon : 'icon-Text_Box'},
                'title':{name: "Title",icon : 'icon-Title'}
            };

            return docuSignToSirionMapper;
        }
        
        function updateCommentAndFeeds(parentCommentId) {
            this.newCommentAdded && this.newCommentAdded(parentCommentId);
            if(_.get(this.feedsResponse,"isCommentBoxAllowed")) {
                $rootScope.commentListScope.fetchFeedsData();
            }
        }

            function getWfSelectionList(url, postBody, entityTypeId) {
                return $http.post(addtStamp(url + '&documentMetaDataCall=yes'), postBody).then(function (res) {
                    if (res?.data?.body &&_.isEmpty(res.data.body.errors)) {
                        if (res.data.body.globalData.renderWfSelectionPage && _.get(res.data, 'body.data.WfSelectionData.values').length > 1) {
                            let wfListData = {
                                listData: res.data.body.data,
                                renderWfSelectionPage: res.data.body.globalData.renderWfSelectionPage,
                                entityTypeId
                            };
                            window.sessionStorage.setItem('wfListData', JSON.stringify(wfListData));
                            window.location.href = '#/raiserequest';
                        }
                    } else if (_.get(res, 'data.header.response.status') !== 'applicationError') {
                        stopLoader();
                        let errormsg = res?.data?.header?.response?.errorMessage || intl_msg[23673];
                        Toaster.create(errormsg);
                    }
                })
            }

        function getFeedsData({entityTypeId, entityId}) {
            return new Promise((resolve,reject) => {
                if(entityTypeId && entityId) {
                    const self = this,
                        urlSuffix = entityTypeId+'/'+ entityId,
                        apiUrl = addtStamp('/wf-action/feed/' + urlSuffix, true);

                    $http({
                        url: apiUrl,
                        method: 'GET'
                    }).then(res => {
                        resolve(res);
                    }).catch(e=>{
                        // console.warn(e);
                    })
                } else resolve(false);
            })
        }
        function getFeedCardList({entityTypeId, entityId,getData= false}) {
            return new Promise((resolve,reject) => {
                if(entityTypeId && entityId) {
                    const apiUrl = addtStamp("/api/feed/list",true);
                    const postJson = {
                        entityId,
                        entityTypeId
                    }
                    $http({
                        url: apiUrl,
                        dataType: 'json',
                        data: JSON.stringify(postJson),
                        method: 'POST'
                    }).then(res => {
                        const entities = _.get(res,"data.entity") || [];
                        const hasEntityData = !!entities.find(entity => !!_.get(entity,"data.id"));
                        if(getData) {
                            resolve(entities);
                        }
                        resolve(hasEntityData);
                    }).catch(e=>{
                        // console.warn(e);
                    })
                } else resolve(false);
            })
        }

        function assignValuesBasedOnActions(actions) {
            $rootScope.preSignature.showContractTemplateSaveButton = false;
            angular.forEach(actions, function (action) {
                if (action.type == 'list' && window.entityURLdata.indexOf("/contracts/") == -1) {
                    $rootScope.backUrl = '#' + action.api.replace('listRenderer/list', 'listRender');
                    $rootScope.backUrlPresent = true;
                    $rootScope.backUrlTitle = action.name;
                }
                if (action.buttonType == 2 && (action.api.indexOf("/tblcdr/update/") > -1 || action.api.indexOf("/tblcontracts/update/") > -1)) {
                    $rootScope.preSignature.showContractTemplateSaveButton = true;
                    window.sarc.channelBroadcast("timelineFeeds",{
                        actionType:'updateAllowStatusValue',
                        allowToUpdateStatus: true
                    },'timelineFeedsSubscription')
                }
            });
        }

        /*** getGFieldModel : function to get the ng-model value as string , to be used in dynamicForm2.js ***/
        function getGFieldModel(model, name, modelType, ngModel) {
            var gFieldModel;
            if (modelType === 'relative') {
                gFieldModel = (angular.isDefined(model) && (model).toString().trim().length > 0) ?
                    (model + "." + name) :
                    (name);
            } else {
                if (angular.isDefined(name) && (name).toString().trim().length > 0) {
                    gFieldModel = (angular.isDefined(model) && (model).toString().trim().length > 0) ?
                        (ngModel + '.' + model + "." + name) :
                        (ngModel + '.' + name);
                } else {
                    gFieldModel = (angular.isDefined(model) && (model).toString().trim().length > 0) ?
                        (ngModel + '.' + model) :
                        (ngModel);
                }

            }
            return gFieldModel;
        }

        function renderPageInbound($scope) {
            if(window.emailTokenValidation) {
                stopLoader();
                if(window.workflowActionDone){
                    var workflowActionResponse = {
                        "type": "success",
                        "notification":intl_msg[9142] ,
                        "heading": intl_msg[24153]
                    };
                    localStorage.setItem("workFlowNotification", JSON.stringify(workflowActionResponse));
                    window.location.href = "/ux/notification.html";
                    window.close();
                }else {
                    VALIDEXTENSIONS = ["doc", "pdf", "xls", "txt", "docx", "xlsx", "jpg", "jpeg", "png", "tif", "tiff", "zip", "gif", "au", "mht", "rtf", "docm", "htm", "html", "msg", "ppt", "pptx", "png", "xlsb", "xlsm"];
                    $scope.saveCommentButton = window.saveCommentButton;
                    delete window.saveCommentButton;
                    $scope.validationBody = window.validationBody;
                    $scope.showPageBody = window.showPageBody;
                    delete window.validationBody;
                    delete window.showPageBody;
                    $scope.workFlowButtons = window.workFlowButtons;
                    delete window.workflowButtons;
                    $scope.processData($scope.showPageBody);
                    $scope.firstLoadByEmail = true;
                    $(document).keydown(function (event) {
                        if (event.keyCode == 123) { // Prevent F12
                            return false;
                        } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I
                            return false;
                        }
                    });
                    $(document).on("contextmenu", function (e) { //Prevent Right Click
                        e.preventDefault();
                    });
                }
            }
        }

        /*********************************** End of getGFieldModel function *******************************/

        /**** checkForApiAndGetData : function to check if the field has a key named as api and get data from that api ***/
        function checkForApiAndGetData(model) {
            model = model.split(".");
            var tempModel = this;
            for (var i = 0; i < model.length; i++) {
                if (tempModel && angular.isDefined(tempModel[model[i]])) {
                    tempModel = tempModel[model[i]];
                } else {
                    return;
                }
            }
            if (angular.isDefined(tempModel["api"]) && tempModel["api"] != null && tempModel["api"].trim().length > 0 && !tempModel["autoComplete"]) {
                var getData = entityFactory.getDataJson(tempModel["api"], "GET");
                getData.then(function (data) {
                    tempModel.data = data.data;
                });
            }
        }

        /********************* End of checkForApiAndGetData function **********************/

        /**** getModelfromString : function to get model value from given string ****/
        function getModelfromString(modelString, baseObj) {
            return dataManipulationService.getModelfromString(modelString, this);
        }

        /********************* End of getModelfromString function **********************/

        /*** setValidity : function to set validity of form fields *****/
        function setValidity(name, isValid) {
            var validFields;
            if (!angular.isDefined(this.validity)) {
                this.validity = {};
                validFields = 0;
            }
            this.validity[name] = isValid;
            getFormValidity.call(this, false);
        }

        /********************* End of setValidity function **********************/

        /** getFormValidity : function to check the validity of a form field ***/
        function getFormValidity(submitting,isClauseSubmit) {
            var self = this;
            if (angular.isDefined(submitting) && submitting) {
                self.validity = {};
                angular.element("[validation2]").each(
                    function () {
                        var skipEditorElement = false;
                        if (typeof angular.element(this).attr("id") != "undefined" && angular.element(this).attr("id").indexOf("textEditor") > -1) {
                            skipEditorElement = true;
                        }
                        if (angular.element(this).attr("disabled") != "disabled" && skipEditorElement == false) {
                            angular.element(this).setDirty;
                            // $scope.setVadlidity($(this).attr("name"),
                            // ($scope.validity.isFormValid ? true : false));

                        angular.element(this).blur();
                    }
                });
                var _retObj = dataManipulationService.fetchTextAreaValues(self.data, window.htmlEditorList,isClauseSubmit);
            }
            if (angular.isUndefined(self.validity)) {
                return false;
            }
            self.validity.isFormValid = true;
            for (var i in self.validity) {
                if (!self.validity.hasOwnProperty(i))
                    continue;
                if (i == "documentFileData") {
                    angular.element("[name='documentFileData']").parent().find("button").removeClass("errorClass");
                }
                if (!self.validity[i] && ['undefined'].indexOf(i) == -1) {
                    if (i == "documentFileData") {
                        angular.element("[name='documentFileData']").parent().find("button").addClass("errorClass");
                    }
                    self.validity.isFormValid = false;
                    break;
                }
            }
            if(angular.isDefined(_retObj) && _retObj.isValid == false){
                self.validity.isFormValid = false;
                if(_retObj.isCommentInvalid == true){
                    if(!$rootScope.mobileView){
                        Toaster.create(intl_msg[7759].replace( "%s",intl_msg[4362]));
                    }
                    else{
                        Toaster.create(intl_msg[7759].replace( "%s",intl_msg[29203]));
                    }
            }
            }
            return self.validity.isFormValid;
        }
    /********************* End of getValidity function **********************/
    /** scrollToElem : function to scroll to a particular div  ***/
    function scrollToElem(myErrorId,errorList,dynamicTblError) {
        //strat code to scroll the page to first errornous field............
        var parentElemToBeScroll = $rootScope.gScrollableElemOnBasePage;
        var elemTillScrolled ;
        var isDelegationCreate = angular.element('.jx-delegationForm').length ? true : false;
        if($rootScope.mobileView){
            parentElemToBeScroll = "div#main";
        }
        else if (angular.element("#angularPopUpHtml").length > 0 && angular.element("#angularPopUpHtml").is(":visible")) {
            parentElemToBeScroll = "div.angularpop-body #mainForm ng-form";//the container of clone page have the overflow:auto
        } else if ((angular.element("#showdialog").length > 0) && angular.element("#showdialog").children().length > 0 && (!angular.element("#showdialog").is(":empty")) && angular.element("#showdialog").is(":visible")) {
            parentElemToBeScroll = "div#showdialog ng-form";
        } else if ((angular.element("#showdialog_list").length > 0) && angular.element("#showdialog_list").children().length > 0 && (!angular.element("#showdialog_list").is(":empty")) && angular.element("#showdialog_list").is(":visible")) {
            parentElemToBeScroll = "div#showdialog_list:eq(0) ng-form";
        } else if (angular.element("table.errorClassDT").length > 0) {
            parentElemToBeScroll = ".jx-parentForm";
        }
        else if (angular.element('.jx-showPageTabContent.active').closest('.tab-detail').length > 0) {
            //parentElemToBeScroll = $('.jx-showPageTabContent.active').closest('.tab-detail').eq(0);
            parentElemToBeScroll = angular.element('.jx-showPageTabContent.active').find('.jx-parentForm');
        } else if (angular.element("#mainContainer").length > 0) {
            parentElemToBeScroll = $rootScope.gScrollableElemOnBasePage;
        }
        if(!isDelegationCreate && (angular.element('#elem_' + myErrorId).length > 0 || angular.element('.fieldset_'+myErrorId).length>0 || myErrorId=="postError")){
        	var errorLists = $(".errorClass");
        	if(errorLists.length){
        	    var formScope = angular.element(errorLists[0]).closest('.dynamic-form ').scope();
                for(var i = 0 ;i<errorLists.length;i++){
                    var errorElem = angular.element(errorLists[i]);
                    if(!errorElem.closest('fieldset:not(.non-box)').hasClass('open')){
                        errorElem.closest('fieldset:not(.non-box)').addClass('open');
                    }
                    if(errorElem.hasClass('ng-valid') && errorElem.hasClass('ng-not-empty') && formScope.errors.fieldErrors && !formScope.errors.fieldErrors[errorElem[0].name]){
                        errorElem.removeClass('errorClass');
                    }
                }
            }

            if(angular.element('.fieldset_'+myErrorId).length>0){
            	angular.element('.fieldset_'+myErrorId).closest('fieldset:not(.non-box)').addClass('open');
            }
        }
        if(dynamicTblError){
            elemTillScrolled = angular.element($("table.errorClassDT").eq(0));
        } else if(errorList && errorList.fieldErrors){
    		var elemName = "";
    		if(_.size(errorList.fieldErrors) > 0){
                angular.forEach(errorList.fieldErrors, function(obj, key){
                    let elemKey = key;
                    if(key.indexOf("rg_")){
                        var splitRG = key.split(".");
                        elemKey = splitRG[splitRG.length - 1];
                    }
                    if(key.lastIndexOf('.')>-1) {
                        key = key.substring(key.lastIndexOf('.') + 1);
                    }
                    if (angular.element("[name="+key+"]").length && angular.element("[name="+elemKey+"]").closest("label").find(".fieldLabel").hasClass("ng-hide") == 0) {
                        elemName = elemKey; // Finding the first error field and return.
                        return;
                    }
                });
            }
    		if(elemName.trim() != ''){
    			elemTillScrolled = '#'+angular.element("[name='" + elemName + "']").closest('span').attr('id');
    		}
    	}
        else if (angular.element('#elem_' + myErrorId).length > 0) {
            var errorHt = 0;
            $('fieldset label textarea').each(function () {
                var errorHt = angular.element(this).parent().find('.sem').height();
                if (errorHt > 0) {
                    angular.element(this).parent().closest('label').css('height', errorHt + 64 + 'px');
                } else {
                    angular.element(this).parent().closest('label').css('height', 'auto');
                }
            });
            elemTillScrolled = '#elem_' + myErrorId;
        }else if (myErrorId == "postError") {//field error before form submit
            // find the first invalid element
            var firstInvalid = angular.element(".errorClass:eq( 0 )").parent().attr("id");
            if(!firstInvalid){
                firstInvalid = angular.element(".errorClass:eq( 0 )").closest('.label-height').attr("id");
            }
            if (firstInvalid) {
                elemTillScrolled = "#" + firstInvalid;
            } else {
                if ($(".errorClass:eq( 0 )").attr('name') == "rateCardsApplicable")
                    elemTillScrolled = ".rateCardsApplicable";
                else
                    angular.noop();
            }

        }
        try {
            var offset = 0;
            if($rootScope.mobileView){
                offset = 100;
            }else{
                offset = parentElemToBeScroll.offset().top;
            }
            if(angular.element(elemTillScrolled).closest('label').length){
                var tempEle = angular.element(elemTillScrolled).closest('label');
                angular.element(parentElemToBeScroll).scrollTo(parentElemToBeScroll.scrollTop() + tempEle.offset().top - offset); // Scroll screen to target element
            }else{
                angular.element(parentElemToBeScroll).scrollTo(elemTillScrolled.offset().top - offset); // Scroll screen to target element
            }

            angular.element(parentElemToBeScroll).scrollLeft(0);
        } catch (e){}
    }
    /********************* End of scrollToElem function **********************/

    /*** setValueOfenableAddComment : Function to set the value of enableAddComment variable to enable or disable the add comment button **/
    function setValueOfenableAddComment(){
    	let commentForm = angular.element('#jx-commentForm');
    	let textAreaField = commentForm.find(".enableUserTagging").length ? escapeHtml(commentForm.find(".enableUserTagging").html().trim()):commentForm.find('iframe').contents().find('.note-editable').text().trim();

    		if(textAreaField == ''  && commentForm.find('.jx-fileListSpan').length == 0){
    			this.enableAddComment = false;
    		}else{
    			this.enableAddComment = true;
    		}

    }
    /********************* End of scrolledCommentSec function **********************/

    /*** preventLabelClick : Function to prevent the propagation of event on label click**/
    function preventLabelClick(){
        $timeout(function () {

            angular.element('label.wideTextarea').click(function(e) {
                e.preventDefault();
            });
            angular.element('label.coveringParent').click(function(e) {
                if(angular.element(this).find('.ang-datepicker').length){
                    e.preventDefault();
                }
               if(angular.element(this).find('.multi-sel').length){
                    if(angular.element(e.target).closest('label').hasClass('jx-msItemCheckBox')){
                        return true;
                    }else{
                        e.preventDefault();
                    }

                }

            });
        }, 1000);
    }
    /********************* End of preventLabelClick function **********************/

    /*** renderActionButtons : Function to render Action button on SHOW PAGE only **/
    function renderActionButtons(btnArr,showPage2DataTransformationService){
        var self = this;
        var printBtn = {
                api: "/listRenderer/list/3",
                "clientValidation": false,
                "confirmationForBlockedEntities": false,
                "hideWorkflowButton": false,
                "name": intl_msg[26888],
                "label": intl_msg[26888],
                "properties": {
                    onClick: {
                        name: "submitData"
                    }
                },
                "buttonPosition":20,
                "buttonType":2,
                "requestType": "Print",
                "secondaryEntity": false,
                "type": "button",
                "id": "print_showPage"
            },
            undoButton = {
                name: "Undo",
                label: intl_msg[27452],
                clientValidation: false,
                type: "button",
                cancelType:true,
                properties: {
                    onClick: {
                        name: "undo"
                    },
                    showCondition: "undoDisable",
                    dontTouchThisButton: true
                },
                "buttonPosition":10,
                "buttonType":3
            };
        if(self.pageType == "show" && btnArr && btnArr.length) { //To enable show page print and undo
            btnArr.push(undoButton);
            if ($rootScope.enableShowPagePrint && !$rootScope.isAEProjectShowPage) {
                btnArr.push(printBtn);
            }
        }
        formService.detailActions = [];
        var indexes = []
        if (btnArr && btnArr.length) {
            var prevActiveMap = {};
            if (formService.buttonMapper) {
                Object.keys(formService.buttonMapper).forEach(function (fId) {
                    formService.buttonMapper[fId].forEach(function (btn) {
                        if (btn.active && btn.properties && btn.properties.buttonType === 'upload') {
                            if (!prevActiveMap[fId]) prevActiveMap[fId] = {};
                            prevActiveMap[fId][btn.name] = true;
                        }
                    });
                });
            }
            formService.buttonMapper = {};
            $rootScope.invoiceBtns = [];
            btnArr.forEach(function (field, i) {
                if (field.properties && field.properties.detailsTab) {
                    formService.detailActions.push(angular.copy(field));
                    indexes.push(i);
                }
                if(field.name == "CreateAdhocChildGB") {
                    self.adHocGbMeeting = true;
                }
                if (field.properties && field.properties.targetLocation) {
                    indexes.push(i);
                    if (!formService.buttonMapper[field.properties.targetLocation]) {
                        formService.buttonMapper[field.properties.targetLocation] = [];
                    }
                    formService.buttonMapper[field.properties.targetLocation].push(field);
                }
                if( field.type == "button" && field.buttonType == 2 && ( field.name == 'Edit' || field.api.indexOf("/tblcontracts/update/") > -1 ) ){
                    self.documentEditPermission = true;
                }
                window.sarc.channelBroadcast("miraDocRepo",{
                    actionType:'updatePermission',
                    documentEditPermission: self.documentEditPermission
                },'miraDocRepoSubscription')
                //@todo Temporary fix. Need to be done by back end team
                if(self.isNewUX && field.api && field.api.indexOf('clone') > -1) {
                    field.properties.onClick.name = "directNonAjax";
                }
            });
            Object.keys(prevActiveMap).forEach(function (fId) {
                if (formService.buttonMapper[fId]) {
                    formService.buttonMapper[fId].forEach(function (btn) {
                        if (prevActiveMap[fId][btn.name]) {
                            btn.active = true;
                        }
                    });
                }
            });
            const docTreeMountInterval = setInterval(()=>{
                const mountAt = '#doc_tree_react';
                if($(mountAt).children().length) {
                    clearInterval(docTreeMountInterval);
                    window.sarc.channelBroadcast("docTreeChannel", {
                        actionType: 'updatePermission',
                        documentEditPermission: self.documentEditPermission
                    }, 'docTreeChannelSubscription')
                }
            },100)
            for (var j = indexes.length - 1; j >= 0; j--)
                btnArr.splice(indexes[j], 1);
        }
        self.actions = btnArr;
        window.sarc.channelBroadcast("wfButtonsReady",{},'wfButtonsReadyChannel');
        showPage2DataTransformationService.separateButtons.call(self,self.actions);
        if(!$rootScope.isAEProjectShowPage){
            if(self.pageType == "show") {
                $rootScope.$broadcast("renderTableButton",true);
            }
            contractTemplateService.renderDownloadButtons($('#tabs-inner-sec').find('.docOptionBar.nav-down'),self.actions);
        }
    }

    // renderCreateLinks : Function to render create links on show pages
    function renderCreateLinks(createLinksObj){
        if (createLinksObj && createLinksObj.fields && createLinksObj.fields.length > 0) {
            this.createLink = createLinksObj.fields;
            if(window.location.href.indexOf('autoExtraction') > -1){
                $rootScope.aeContractCreationLinks=createLinksObj.fields;
            }
            if (this.data && this.data.contract && this.data.contract.values && this.data.contract.values.id) {
                this.contractPrevId = this.data.contract.values && this.data.contract.values.id;
            } else {
                this.showBackNavigation = false;
            }
            this.showPlusSign = true;
        } else {
            this.createLink = undefined;
            this.showPlusSign = false;
        }
    }
    /********************* End of renderActionButtons function **********************/

    function setPositionOfDatepicker(elem,isCliInstance){
        let elemTop = angular.element(elem).offset().top,
            elemLeft = angular.element(elem).offset().left,
            elemHeight = angular.element(elem).outerHeight(),
            calTop = elemTop+elemHeight,
            calHeight = angular.element(elem).next('.datetime-picker-dropdown').height();

        if(angular.element(elem).closest('.clonepopup').length){
            elemLeft = elemLeft - angular.element(elem).closest('.clonepopup').find('.modal-content').offset().left;
            calTop = calTop - angular.element(elem).closest('.clonepopup').find('.modal-content').offset().top;
            if(calHeight+calTop > (angular.element(elem).closest('.clonepopup').find('.modal-content').height())){
                calTop = calTop-((calTop+calHeight)-angular.element(elem).closest('.clonepopup').find('.modal-content').height());
            }
        }
        if(calHeight+calTop > (angular.element(window).height())){
            if(angular.element(elem).closest('.jx-parentForm').length){
                calTop = angular.element(window).height() - calHeight - angular.element('#footer').outerHeight()-5;
            }else{
                calTop = calTop-((calTop+calHeight)-angular.element(window).height());
            }
            if(isCliInstance) {
                calTop -= 30;
                angular.element(elem).next('.datetime-picker-dropdown').find('thead th').css({'position':'unset'})
            }
        }
        angular.element(elem).closest('.scrollTbody').css('overflow','visible');
        angular.element(elem).next('.datetime-picker-dropdown').css({'top':calTop+'px','left':elemLeft+'px','position':'fixed'});
        if(isCliInstance){
            var positionFromLeft = $('.datetime-picker-dropdown').css("left");
            if((parseInt($('.datetime-picker-dropdown').width()) + parseInt(positionFromLeft.slice(0,-2))) > parseInt(window.innerWidth)) {
                angular.element(elem).next('.datetime-picker-dropdown').css({'top':calTop+'px','left':'auto', 'right': '0px','position':'fixed'});
            }
        }
    }

    function setLocalListingSwitchData(data) {
        if(_.size(data) == 0 ){
            this.showLocalListingList = false;
            return;
        }
        var retval = [];
        for (var obj in data) {
            var retObj = {};
            if (data[obj] === true) {
                if( $rootScope.entityListIdNameMap && $rootScope.entityListIdNameMap[obj]){
                    retObj["label"] = $rootScope.entityListIdNameMap[obj];
                    retObj["listId"] = obj;
                }
                else if ( $rootScope.entityListIdNameSuperMap && $rootScope.entityListIdNameSuperMap[obj] ) {
                    retObj["label"] = $rootScope.entityListIdNameSuperMap[obj];
                    retObj["listId"] = obj;
                }
               else{
                    console.log("List id ***- "+obj+" -*** is not found in UI-Entity-Map")
                }
                if(retObj["label"] && retObj["listId"]){
                    retval.push(retObj);
                }
            }
        }
        if (!SirionUtils.isEmpty(retval) && SirionUtils.isArray(retval)) {
            this.showLocalListingList = true;
            $rootScope.lazyLoadForLocalListing = false;
            this.localListingList = retval.sort(function(a,b){return a.label.localeCompare(b.label)});
            this.showNoData = !this.localListingList;
            return this.localListingList;
        }
     };

    function getLocalListingURL(entityTypeId,entityId){
        let retval = "/listRenderer/localList/status/"+ entityTypeId + "?";
        if(entityTypeId == 1){
            retval+="relationId="+entityId;
        }
        else if(entityTypeId == 61){
            retval+="contractId="+entityId;
        }
        else if(entityTypeId == 3){
            retval+="vendorId="+entityId;
        }
        return retval;
    }

    function isLocalListingPermissible(entityTypeId){
        let retval = false;
        let allowedEntityArr = [1,3,61];
        if(allowedEntityArr.indexOf(entityTypeId) > -1 ){
            retval =true;
        }
        return retval;
    }

    function isLocalListingEnabled(entityTypeId){
        let retval = false;
        if(entityTypeId == null){
            return retval;
        }
        let allowedEntityArr = [1,3,61];
        if(allowedEntityArr.indexOf(entityTypeId) > -1 && this.showLocalListingList ){
            retval =true;
        }
        return retval;
    }

    function setLocalListingHistory(_args,_entity,_entityTypeId,pageType){
        this.localListEntityId = _entity.id;
        this.localListEntityName = _entity.name;
        this.localListEntityTypeId =_entityTypeId;
        this.localListingBackHash = addtStamp("#/"+pageType+"/"+NumToURLPartMapping[_entityTypeId]+"/"+this.localListEntityId);
    }

    function getLocalListingBackURL(){
        return this.localListingBackHash;
    }

    function getOnlyFieldIds(data) {
        const cData = this.data || {};
        const dependentFields = [].concat(data || []);
        let relationIds = [];
        dependentFields.forEach(fld => {
            let _relationIds = [];
            if(_.get(cData[fld],"values.length")) {
                _relationIds = cData[fld].values.map(function (obj) {
                    return obj.id
                });
            } else {
                _relationIds = [cData[fld].values.id];
            }
            relationIds = relationIds.concat(_relationIds);
        })
        return relationIds;
    }

    function checkCDRimportEnability(field,docTreeService,sc){
        var apiParamObj = {};
        if(field && field.api && field.api.split("?")[1]) {
            var params = field.api.split("?")[1];
            const cdrToContractPortingEnabled = [61, 9, 10]; // [Contracts, SOW, Work Order]
            params && params.split("&").forEach(function (item, index) {
                apiParamObj[item.split("=")[0]] = item.split("=")[1];
            })
            if((cdrToContractPortingEnabled.indexOf(parseInt(apiParamObj.actualParentEntityTypeId)) > -1) && apiParamObj.sourceEntityTypeId == 160 && apiParamObj.sourceEntityId && !docTreeService.cdrToContractPorting){
                docTreeService.cdrToContractField = angular.copy(docTreeService.baseCdrToContractDocMovementField);
                docTreeService.cdrToContractField[0].dataURL += (apiParamObj.sourceEntityTypeId + '/' + apiParamObj.sourceEntityId);
                docTreeService.cdrToContractField[0].id = Math.floor(Math.random() * 100000);
                $("body").addClass("overRideLoading");

                sc.$$postDigest(function(){
                    if(!sc.$$phase){sc.$apply()};
                    docTreeService.cdrToContractPorting = true;
                    sessionStorage.setItem('cdrToContractPorting',docTreeService.cdrToContractPorting);
                    sessionStorage.setItem('cdrToContractField',JSON.stringify(docTreeService.cdrToContractField));
                    $compile($(".importFromCdr [my-table]"))(sc);
                })
                return true;
            } else if(sc.showAmendment){
                sc.$$postDigest(function(){
                    if(!sc.$$phase){sc.$apply()};
                    docTreeService.contractToCdrPorting = true;
                })
                return true;
            }
            else{
                docTreeService.cdrToContractPorting = false;
                delete docTreeService.cdrToContractField;
                docTreeService.contractToCdrPorting = false;
                delete docTreeService.contractToCdrPorting;
            }
        }else{
            docTreeService.cdrToContractPorting = false;
            delete docTreeService.cdrToContractField
            docTreeService.contractToCdrPorting = false;
            delete docTreeService.contractToCdrPorting;
        }
        return false;
    }

        function initDocTreeFilters(event,reactDocTreePermission) {
            var target = event.srcElement || event.target;
            if(target && target.closest && target.closest(".filter-search")){
                event.stopPropagation();
                return;
            }
            if (event && !event.originalEvent) {
                return;
            }
            var scope = $(".Filter-detail").scope();
            docTreeDatePickerFunctions(scope);
            var docFilterEle =angular.element(".docTreeFilter .Filter-detail");
            if(reactDocTreePermission){
                docFilterEle.css("min-width",200);
                docFilterEle.css("max-width",200);
                docFilterEle.css("height",angular.element("#doc_tree_react").height());
            }else{
                docFilterEle.css("min-width",angular.element("#tree").width());
                docFilterEle.css("max-width",angular.element("#tree").width());
                docFilterEle.css("height",angular.element("#tree").height());
            }
            var promise = new Promise(function (resolve, reject) {
                var element = angular.element("#left_menu");
                var docTreeFilterDataUrl = apiVersioning.getApiDynamicVersion("listRenderer_filterController") + scope.docTreeListId + "/filterData?relationId=" + (window.relationId || '') + "&contractId=" + (window.contractId || '') + "&am=true";
                if (retObj.docTreeFilterRendered == false && ($.isEmptyObject(filterDataJson))) {
                    retObj.docTreeFilterRendered = true;
                    $http({
                        url: docTreeFilterDataUrl,
                        dataType: 'json',
                        data: JSON.stringify(filterQueryParam),
                        method: 'POST'
                    }).then(function successCallback(response) {
                        docTreeFilterDataJson = angular.copy(response.data);
                        filterDefaultDataJson = angular.copy(response.data);
                        defaultFilterDataJson = angular.copy(response.data);
                        if (defaultFilterLayoutData && defaultFilterLayoutData.filterMap) {
                            filterData = defaultFilterLayoutData.filterMap.filterJson;
                            docTreeFilterDataJson = defaultFilterLayoutData.filterMap.filterJson;
                        } else {
                            filterData = defaultFilterDataJson;
                        }
                        renderDocTreeFilters(filterData, element, response.data, resolve);
                        populatePrefView();
                    }, function errorCallback(response) {
                        console.log("Error loading filterData");
                        reject("failed");
                    });
                } else if (retObj.docTreeFilterRendered == false &&  preserveFltrMap && preserveFltrMap.filterDataJson) {
                    docTreeFilterDataJson = preserveFltrMap.filterDataJson;
                    filterDefaultDataJson = preserveFltrMap.filterDefaultDataJson;
                    defaultFilterDataJson = preserveFltrMap.filterDefaultDataJson;
                    var filterData;
                    if (defaultFilterLayoutData && defaultFilterLayoutData.filterMap) {
                        filterData = defaultFilterLayoutData.filterMap.filterJson;
                    } else {
                        filterData = defaultFilterDataJson;
                    }
                    renderDocTreeFilters(filterData, element, filterData, resolve);
                    resolve("done");
                } else if ((element.find(".jx-listFilters").length == 0 && $.isEmptyObject(filterDataJson) == false) || $rootScope.docTreeScpCompiled) {
                    if($rootScope.docTreeScpCompiled) {
                        delete $rootScope.docTreeScpCompiled;
                        docTreeFilterDataJson = preserveFltrMap.filterDataJson;
                        filterDefaultDataJson = preserveFltrMap.filterDefaultDataJson;
                    }
                    renderDocTreeFilters(filterDataJson, element, defaultFilterDataJson, resolve);
                    resolve("done");
                }
                else{
                    resolve("done");
                }
            });
            return promise;
        }
        function docTreeDatePickerFunctions(scope) {
            filterService.setUpdateMSOptions.call(scope);
            var updateDepDDEvt = filterService.setDependentFilterEvent.call(scope);
            scope.msEvents = {'onClose':scope.updateMSoptions};
            var listingskeletontoggleEvt= scope.$on("listing skeleton toggle", function(e,listDataTable, listHeader){
                scope.showListHeaderSkeleton = listHeader;
                scope.showListDataTableHeader = listDataTable
                if(!scope.$$phase) {
                    scope.$apply();
                }
            });
            var closeDatePicker = scope.$on('closeDatePicker',function(e){
                scope.datepickerFilter.opened.fromDate= {};
                scope.datepickerFilter.opened.toDate= {};
            });
            filterService.setUpDatePicker.call(scope);
        }

        function renderDocTreeFilters(filterData, element, allFilterData, resolve) {
            defaultFilterLayoutData = null;
            var scope = $(".Filter-detail").scope();
            if (filterMetaDataJson && filterMetaDataJson.length == 0)
                filterMetaDataJson = listJson.filterMetadatas;
            scope.filterOptions = _.keyBy(filterMetaDataJson, 'queryName');
            for (var k in scope.filterOptions) {
                scope.filterOptions[k]['data'] = filterDataJson[scope.filterOptions[k]['id']];
            }
            element.find('.filter-content').populateCustomFilter({
                "metaData": filterMetaDataJson,
                "data": filterData,
                "allFilterData": allFilterData
            }, undefined, undefined, undefined, true);
            $timeout(function () {
                scope.$apply();
                if (typeof resolve == 'function') {
                    resolve("done");
                }
            }, 0);
        }

        function toggleDocTreeFilterPanel(val, e) {
            if(e) {
                var ele = angular.element(e.originalEvent.toElement);
                if ($("#filter").is(":visible") == true && ele.hasClass('icon-filter') == true && val == true) {
                    val = false ;
                }
            }
            if (val !== undefined) {
                if (e && angular.element((e.target || e.srcElement)).hasClass('jx-filterToggle') && retObj.showDocTreeFilterPanel) {
                    retObj.showDocTreeFilterPanel = false;
                } else if (e && angular.element(e.target || e.srcElement).hasClass('filter-buttons')) {
                    retObj.showDocTreeFilterPanel = false;
                } else {
                    retObj.showDocTreeFilterPanel = val;
                }
            }
            var scope = $(".Filter-detail").scope();
            if(!retObj.showDocTreeFilterPanel && scope && scope.clearSearch && e && !$(e.target).hasClass("reset"))
                scope.clearSearch(e);
            retObj.showDocTreeFilterPanel && commonUtil.setHeightOfListFilterPanel();
            if(retObj.showDocTreeFilterPanel == true){
                (function () {
                    setTimeout(function () {
                        if(e && e.originalEvent) {
                            var ele = angular.element(e.originalEvent.toElement);
                            if(ele.hasClass('icon-filter') == true) {
                                document.getElementById('filterSearchId').focus();
                            }
                        }
                    }, 0);
                })();
            }
        };

        function isFieldValueDifferent (previousData, newData) {
            const notValue = [undefined, null, ""];
            if(notValue.includes(previousData) && notValue.includes(newData)) return false;
            if(previousData != newData) return true;
            return false;
        }

        function checkBlankRelatedOperator (operator) {
            return ["BLANK", "NOT_BLANK"].includes(operator);
        }

        function compareTwoSelectedValue (dataA, dataB) {
                if(checkBlankRelatedOperator(dataA.operator) && checkBlankRelatedOperator(dataA.operator))
                    return false;
                let selectedIds = [];
                if(dataA.multiselectValues?.SELECTEDDATA?.length) {
                    dataA.multiselectValues.SELECTEDDATA.forEach(option => {
                        selectedIds.push(option.id);
                        if (option.value || option.name) selectedIds.push(option.value || option.name);
                    })
                }
                if(dataB.multiselectValues?.SELECTEDDATA?.length) {
                    dataB.multiselectValues.SELECTEDDATA.forEach(option => {
                        const index = selectedIds.indexOf(option.id);
                        if (index > -1) selectedIds.splice(index, 1)
                        if(option.value || option.name) {
                            const index = selectedIds.indexOf(option.value || option.name);
                            if (index > -1) selectedIds.splice(index, 1)
                        }
                    })
                }
                let reverseSelectedIds = [];
                if(dataB.multiselectValues?.SELECTEDDATA?.length) {
                    dataB.multiselectValues.SELECTEDDATA.forEach(option => {
                        reverseSelectedIds.push(option.id);
                        if (option.value || option.name) reverseSelectedIds.push(option.value || option.name);
                    })
                }
                if(dataA.multiselectValues?.SELECTEDDATA?.length) {
                    dataA.multiselectValues.SELECTEDDATA.forEach(option => {
                        const index = reverseSelectedIds.indexOf(option.id);
                        if (index > -1) reverseSelectedIds.splice(index, 1)
                        if(option.value || option.name) {
                            const index = reverseSelectedIds.indexOf(option.value || option.name);
                            if (index > -1) reverseSelectedIds.splice(index, 1)
                        }
                    })
                }
                return selectedIds.length || reverseSelectedIds.length;
            }


        function checkHasValue (field) {
            if(!field) return;
            let elm = $("#listFilter" + field.filterName);
            let type = field.uiType || field.uitype || field.UIType;
    
            let hasValue = true;
            const validOperator = field.operator && !["NOT","AND", "not", "and"].includes(field.operator);
            const emptyValues = [null,'',undefined];
            if(!type) hasValue = false;
            else if(type == "DATE" &&
                ((!field["startDate"] && !field['endDate'] && !field["start"] && !field["end"]  && emptyValues.includes(field["dayOffset"]) && emptyValues.includes(field["duration"])) ||
                    (!emptyValues.includes(field["dayOffset"]) && !emptyValues.includes(field["duration"]) && field["duration"] < 0) ) &&
                    !validOperator){
                hasValue = false;
            }
            else if((type == "MULTISELECT" || type == "SINGLESELECT" || type == "STATUS" || type == "STAKEHOLDER" || type == "KEYVALUE")){
                if((!field["multiselectValues"] || !field["multiselectValues"]["SELECTEDDATA"] || field["multiselectValues"]["SELECTEDDATA"].length == 0) && !validOperator) {
                    hasValue = false;
                }
            }
            else if((type == "TEXTRANGE" || type == "SLIDER" || type == "INPUTTEXT" || type == "TEXT") && !field["min"]  && !field["max"] && !validOperator){
                hasValue = false;
            }
            if(hasValue){
                if(!elm.hasClass("selected")){
                    elm.addClass(" selected");
                }
            } else {
                if(elm.hasClass("selected")){
                    elm.removeClass(" selected");
                }
            }
            return hasValue;
        
        }



        function  checkFieldDataTypeSimilar (previousData, newData, key) {
            const emptyValues = [null,'',undefined];
            if(emptyValues.includes(previousData[key]) && emptyValues.includes(newData[key])) {
                return false;
            }
            return true;
        }
        
        function getUiTypeById(metadataArray, id) {
            const item = metadataArray.find(meta => meta.id === id);
            return item ? item.uiType : null; // Return the uiType or null if not found
          }

        function isFilterDataDifferent (previousData, newData) {
                let type = getUiTypeById(window.filterMetaDataJson, previousData.filterId);
                previousData.uiType = newData.uiType = type;
                if(!newData) return true;
                if(checkHasValue(previousData) || checkHasValue(newData)) {
                    if(type === "DATE") {
                        if(compareTwoSelectedValue(previousData, newData) || previousData["operator"] != newData["operator"]){
                            return true;
                        } else {
                          let dateType = previousData["multiselectValues"]["SELECTEDDATA"].length &&  previousData["multiselectValues"]["SELECTEDDATA"][0].id;
                          if(dateType == 1) {
                              if((checkFieldDataTypeSimilar(previousData, newData, "start") && previousData["start"] != newData["start"]) || (checkFieldDataTypeSimilar(previousData, newData, "end") && previousData["end"] != newData["end"])){
                                  return true;
                              }
                          } else if(dateType == 2 || dateType == 3){
                            if((checkFieldDataTypeSimilar(previousData, newData, "dayOffset") && Number(previousData["dayOffset"]) != Number(newData["dayOffset"])) || (checkFieldDataTypeSimilar(previousData, newData, "duration") &&  Number(previousData["duration"]) != Number(newData["duration"]))){
                                return true;
                            }
                          }
                        }
                    } else if((type == "MULTISELECT" || type == "SINGLESELECT" || type == "STATUS" || type == "STAKEHOLDER" || type == "KEYVALUE")){
                        if(previousData["multiselectValues"]["SELECTEDDATA"].length !== newData["multiselectValues"]["SELECTEDDATA"].length || compareTwoSelectedValue(newData, previousData) || previousData.operator != newData.operator) {
                            return true;
                        }
                    } else if((type == "TEXTRANGE" || type == "SLIDER" || type == "INPUTTEXT")) {
                        if(isFieldValueDifferent(previousData["min"],newData["min"]) || isFieldValueDifferent(previousData["max"],newData["max"]) || previousData["operator"] != newData["operator"]) {
                            return true;
                        }
                    }
                }
                return false;
            }

        function compareTwoFilters () {
               let scope = $(".Filter-detail").scope();
               let dataJson = window.filterDataJson;
                for(const i in dataJson) {
                    let id = dataJson[i].filterId
                    if(!_.isEmpty(scope.initialPrefViewFilterDataObj)){
                        if(scope.initialPrefViewFilterDataObj[id] && isFilterDataDifferent(scope.initialPrefViewFilterDataObj[id],window.filterDataJson[id])) {
                           return true;
                        }
                    }
                    else {
                        if(!_.isEmpty(window.filterDefaultDataJson) && isFilterDataDifferent(window.filterDefaultDataJson[id], window.filterDataJson[id])) {
                            return true;
                        };
                    }
                }
                return false;
            }

        function applyFilterOnDocTree(fromReset = false) {
            showDoctreeSkeleton(true);
            var scope = $(".Filter-detail").scope();
            let preferenceScope = $("#docTreePreferenceFilter").scope()
            const docTreeFilterMutated = !fromReset && compareTwoFilters();
            if(docTreeFilterMutated){
                preferenceScope.resetDocTreeSaveBanner(true);
            } else {
                preferenceScope.resetDocTreeSaveBanner(false);
            }
            setTimeout(function () {
                loadTree(scope.currentRelationId, undefined, true, scope.data.id.values, true);
            }, 100)
        };

       function resetFavourites(e,isClickedOutside){
            if($(".create").position() && $(".create").position().left + 238 > $("#tree").width()){
                $(".savedViewDD").css("left","-84px");
            }
            else{
                $(".savedViewDD").css("left","0px");
            }
            var currentSelection =  $('#privateViewBtn').is(':checked')? "private" : "public";
            if(  ( "private" != currentSelection || isClickedOutside ) && !$(".DropdownBox.savedViewDD").is(":visible") ) {
                $(".savedViewDD .showViewTypeRadio input[name=showViewType]:checked").val("private");
                $("#privateViewBtn").prop("checked", true);
                SirionUtils.refreshFavourite( "private" );
            }
        };
        function setViewType(val){
            if(val == "private"){
                $('#privateViewBtn').prop("checked", true);
            }
            else{
                $('#publicViewBtnRadio').prop("checked", true);
            }
        };
        function emptyDependentField(fieldData,id,onlyAdded){
            const dependentFields = [].concat(fieldData.dependentField || fieldData.dependentFields || []);
            if(dependentFields.length) {
                var that = this,
                    dynData = that.data.dynamicMetadata,
                    dpFld = fieldData.dependentField,
                    removeDependentField = function() {
                        var exemptedFields = ["contracts"];
                        if(exemptedFields.indexOf(fieldData.name) > -1){
                            return;
                        }
                        dependentFields.forEach(dpFld => {
                            var depElm = $("[fieldname='"+dpFld+"']");
                            if(depElm.length) {
                                var selectedDepElms = depElm.closest(".label-height").find(".jx-selected .showSelected>i");
                                if(selectedDepElms.length){
                                    if(id) {
                                        selectedDepElms.each(function(i,selItem){
                                            var optionData = $(selItem).attr("data-option") && JSON.parse($(selItem).attr("data-option"))
                                            if(optionData.parentId == id){
                                                $(selItem).trigger("click");
                                            }
                                        })

                                    }else{
                                        if(!onlyAdded) {
                                            selectedDepElms.each(function (i, selItem) {
                                                $(selItem).trigger("click");
                                            })
                                        }
                                    }
                                }else{
                                    depElm.val(null);
                                    if(dynData && dynData[dpFld] && dynData[dpFld].values){
                                        dynData[dpFld].values = null;
                                    }
                                }
                                depElm.trigger("change");
                            }
                        })
                    }
                if(dynData[dpFld] && angular.isDefined(dynData[dpFld].values)){
                    if(!dynData[dpFld].values || (!!(dynData[dpFld].values instanceof Array) && !dynData[dpFld].values.length)){
                        return;
                    }
                    removeDependentField();
                    if(!this.$$phase)this.$apply();
                }
                else{
                    if( !!(dynData.values instanceof Array) && !dynData.values.length){
                        return;
                    }
                     dynData = this.data[fieldData.name];
                    if(!this.$$phase)this.$apply();
                     removeDependentField()
                }
            }
        };
        function getDataForDependentField(){
            var  dynData = this.data.dynamicMetadata;
            var parentFieldValues;
            if(dynData[this.parentFieldName]){
                parentFieldValues = dynData[this.parentFieldName].values;
            }else{
                dynData  = this.data[this.parentFieldName];
                parentFieldValues = dynData.values;

            }
            var parentFieldSelectedValues = [];

            if(parentFieldValues) {
                if (!!(parentFieldValues instanceof Array)) {
                    for (var i = 0; i < parentFieldValues.length; i++) {
                        parentFieldSelectedValues[i] = parentFieldValues[i].id;
                    }
                } else {
                    parentFieldSelectedValues = [parentFieldValues.id];
                }
            }
            return parentFieldSelectedValues;
        }
        function createAeDocPropContainer(tElm){
            var pContainer = tElm.closest("div");
            if(pContainer.find(".aeDocPropContainer:visible").length){
                return null;
            }else{
                $(".aeDocPropContainer").remove();
            }
            var elmToAppend = $('<div ae-doc-prop="" click-outside="removePropContainer()" outside-if-not=".col_wrap_documentname,.aeDocPropContainer" class="aeDocPropContainer"></div>');
            var topVal = pContainer.offset().top-5
            if(($(window).outerHeight() - pContainer.offset().top) < 270){
                topVal = $(window).outerHeight() - 295;
            }
            var styleToAppend = {
                top:topVal,
                left:pContainer.offset().left+25
            }
            this.docPropData = {};
            this.docPropData.docId = tElm.attr("data-docId");
            var rowData =  this.$parent.aeListDataMap[this.docPropData.docId];
            this.docPropData.projectsVal = SirionUtils.iterateTableData(rowData,"projects");
            this.docPropData.groupsVal = SirionUtils.iterateTableData(rowData,"groups");
            this.docPropData.doctagsVal = SirionUtils.iterateTableData(rowData,"doctags");
            this.docPropData.tag1Val = SirionUtils.iterateTableData(rowData,"doctag1");
            this.docPropData.tag2Val = SirionUtils.iterateTableData(rowData,"doctag2");
            this.projectId = SirionUtils.iterateTableData(rowData,"projects");

            elmToAppend.css(styleToAppend);
            pContainer.append(elmToAppend);
            return pContainer;
        }
        function createStrategyCloneContainer(tElm){
                var pContainer = tElm.closest("div");
                if(pContainer.find(".seCloneContainer").length){
                    return null;
                }else{
                    $(".seCloneContainer").remove();
                }
            var elmToAppend = $(` <div class="seCloneContainer" outside-if-not=".dataTables_scrollBody,.col_type_truncate,.icon-more .docPropEdit" click-outside="removeCloneContainer($event)">
                <ul>
                    <li ng-click="cloneStrategy(${pContainer[0].id})" ng-if="${window?.strategyProperties?.hasCloneStrategyPermission}">
                        <div><i class="icon-Clone"></i>Clone</div>
                    </li>
                    <li ng-click="extractStrategy(${pContainer[0].id})" ng-if="${window?.strategyProperties?.hasExportStrategyPermission}">
                        <div><i class="icon-Reference"></i>Export</div>
                    </li>
                </ul>
            </div>`)
                var topVal = pContainer.offset().top;
                var styleToAppend = {
                    top:topVal+30,
                    right:20,
                    position:'fixed',
                    width:'100px'
                }
                elmToAppend.css(styleToAppend);
                pContainer.append(elmToAppend);
                return pContainer;
            }

        function loadTemplateContent(attrs) {
            var {scope, url, element, templateId, offset, limit, outlineData, tagData, postTags,_extraFlags} = attrs;
            var eleSelector = scope.renderInPdfJs ? "#docContainer" : "#tabs-inner-sec";
            if(_.get(scope.previewTab, "isActive") && scope.previewTab.isActive) {
                $(element).find(eleSelector).addClass("contractTemplateContent");
            } else {
                $(element).closest(eleSelector).addClass("contractTemplateContent");
            }
            var el = $(element);
            stopLoader();
            var isTemplate = false;
            var checkForCDRPage  = () => {
                if(window.location.href.indexOf('templateWizard/cdr') > -1)
                    return true;
                return false;
            }
            startLoader();
            if (url.indexOf("/tblcontracttemplate/") > -1) {
                isTemplate = true;
            }
            if(!$rootScope.documentPageCordinates){
                $rootScope.documentPageCordinates = {};
            }
            if(scope.docuSign || $rootScope.aeDocShowPage || (!$rootScope.templateSuggestionPage && scope.data.entityTypeId.values == 140) || scope.data.entityTypeId.values == 138 || (scope.previewTab && scope.previewTab.isActive)){
                var docApiUrl = '/documentviewerstream/check/';
                if(scope.docuSign){
                    docApiUrl = '/documentviewerstream/check/'+scope.data.entityTypeId.values+'/'+ scope.showpageData.id +'/78/'+scope.fileId + '?auditLogDocumentId='+ templateId;

                    // CA-5633 | Enable sendForSignature flow
                    if(scope.params[1] == 'sendSignature' && scope.data.entityTypeId.values == 160)
                        docApiUrl += '&signatureDocument=true&allowDynamicConversion=true';//allowDynamicConversion=true for test
                }else{
                    if(scope.OriginalCheckRequired){
                        docApiUrl = '/documentviewerstream/check/' + scope.data.entityTypeId.values + "/" + templateId + "/" + scope.data.entityTypeId.values + "/" + templateId + '?checkOriginal=true&&allowDynamicConversion=true&auditLogDocumentId='+scope.data.entityTypeId.values;
                    } else if(scope.previewTab && scope.previewTab.isActive){
                        docApiUrl = docApiUrl + scope.data.entityTypeId.values + '/' + scope.data.id.values + '/' + scope.entityTypeId + '/' + scope.entityId + '?auditLogDocumentId=' + scope.auditLogDocumentId;
                    } else {
                        docApiUrl = docApiUrl + scope.data.entityTypeId.values + '/';
                        var auditlogId = '?auditLogDocumentId=';
                        if (scope.data.id && scope.data.id.values && !scope.aeDocShowPage) {
                            docApiUrl = docApiUrl + scope.data.id.values + '/' + scope.data.entityTypeId.values + '/' + scope.data.id.values;
                            auditlogId = auditlogId + scope.data.id.values;
                        }
                        if (!scope.data.id || scope.aeDocShowPage) {
                            docApiUrl = docApiUrl + templateId + '/' + scope.data.entityTypeId.values + '/' + templateId;
                            auditlogId = auditlogId + templateId
                        }

                        if(scope.aeDocShowPage){
                            docApiUrl = docApiUrl + '?allowDynamicConversion=true&&auditLogDocumentId='+ scope.data.entityTypeId.values;
                        }else if(scope.versionNumber){
                            var templateVersionNumber = '&versionNumber=' + scope.versionNumber ;
                            docApiUrl =  docApiUrl  + '/' + auditlogId + templateVersionNumber + '&&allowDynamicConversion=' + true;
                        }else {
                            docApiUrl =  docApiUrl +  '/' + auditlogId + '&&allowDynamicConversion=' + true;
                        }


                    }
                }
                docApiUrl = addtStamp(docApiUrl,true);
                return $http.get(docApiUrl).then(function (response) {
                    if (_.has(response,'data.data') && response.data.data!= null) {
                        $rootScope.documentPageCordinates.bottom = false;
                        $rootScope.tabListDataLoaded = false;
                        $rootScope.pdfDataLoading = false;
                        if(scope.versionNumber){
                            response.data.data.documentURL += '&versionNumber=' + scope.versionNumber
                        }
                        if(scope.OriginalCheckRequired){
                            response.data.data.documentURL += "&checkOriginal=true";
                        }

                        contractTemplateService.renderDocHtmlView(element, scope, response.data.data, isTemplate, outlineData, tagData, true);
                        stopLoader();
                        if(_extraFlags  && _extraFlags._showTagsUpdatedMsg){
                            Toaster.create(intl_msg[29017]);
                            /*sDialog.on("dialogclose", function () {
                                if (sDialog) {
                                    sDialog.dialog("destroy");
                                }
                            });*/
                        }
                    }
                    else {
                        if(scope.OriginalCheckRequired){
                            scope.OriginalCheckRequired =false;
                            scope.toggleOriginalAeDocument( false);
                            SirionUtils.openSirionDialogs({popupType: 'alert', str: 'Document is yet To be indexed.Please try again in some time.', heading: intl_msg[24153]});
                            stopLoader();
                        }
                        else {
                            var pages = 100; // Variable to be set for getting no. of pages on a request.
                            var errorMsg = response.data.error[0] && response.data.error[0].message;
                            var noDataHtml = "<div class='noTemplate'><div class=\"noDataToDisplay\"><div class=\"no-data-image\">  <video style='height: 115px;' id=\"docViewerNoData\"   muted=\"true\" preload=\"auto\" autoplay loop><source src=\"src/images/mp4/doc-viewer.mp4\"  type=\"video/mp4\"></video><span class=\"no-data-text\">" + errorMsg + "</span></div></div>";
                            $rootScope.tabListDataLoaded = false;
                            $rootScope.pdfDataLoading = false;
                            $rootScope.documentPageCordinates.bottom = true;
                            $rootScope.documentPageCordinates.offset = $rootScope.documentPageCordinates.offset - pages;
                            if(scope.docuSign){
                                if(!el){
                                    window.setTimeout(function () {
                                        el.append(noDataHtml);
                                    },10)
                                }else{
                                    el.append(noDataHtml);
                                }
                            }else{
                                el.closest('.tab').addClass("no-template").append(noDataHtml);
                            }
                            stopLoader();
                        }
                    }
                    }).catch(()=> {
                        stopLoader();
                    });
                }
            else{
                    var postData = {"entityId": templateId};
                    if(checkForCDRPage()) {
                      postData.parentEntityTypeId = scope.entityTypeId;
                      postData.parentEntityId = scope.entityId;
                    }
                    if(scope && scope.selectedTemplateTags && scope.selectedTemplateTags.templateVersion) {
                        postData["versionNumber"] = scope.selectedTemplateTags.templateVersion
                    }
                    if (postTags) {
                        var postTagsCopy = angular.copy(postTags);
                        angular.forEach(postTagsCopy, function (data) {
                            data.$$hashKey ? delete data.$$hashKey : "";
                            data.entityField ? delete data.entityField : "";
                            data.tagHTMLType ? delete data.tagHTMLType : "";
                            data.orderSeq ? delete data.orderSeq : "";
                            data.identifier ? delete data.identifier : "";
                        });
                        postData.mappedTags = postTagsCopy;
                    }
                    $http.post(url, JSON.stringify(postData)).then(function (response) {
                        $rootScope.tabListDataLoaded = false;
                        $rootScope.pdfDataLoading = false;
                        if (response && response.data != "") {
                            contractTemplateService.renderDocHtmlView(element, scope, response.data, isTemplate, outlineData, tagData, false);
                            $rootScope.documentPageCordinates.bottom = false;
                            if(_extraFlags  && _extraFlags._showTagsUpdatedMsg){
                                Toaster.create(intl_msg[29017]);
                                /*sDialog.on("dialogclose", function () {
                                    if (sDialog) {
                                        sDialog.dialog("destroy");
                                    }
                                });*/
                            }
                        } else {
                            var noDataMsg = (intl_msg[29605] || "No template available for preview");
                            var noDataHtml = "<div class='noTemplate'><div class=\"noDataToDisplay\"><div class=\"no-data-image\"><img loading=\"lazy\" alt=\"no data image\" src='https://www.sirioncdn.com/src/images/no-data.svg' height=\"115px\"/></div><span class=\"no-data-text\">"+noDataMsg+"</span></div></div>";

                            var pages = 100; // Variable to be set for getting no. of pages on a request.
                            $rootScope.documentPageCordinates.bottom = true;
                            $rootScope.documentPageCordinates.offset = $rootScope.documentPageCordinates.offset - pages;
                            const parentElm = el.closest('.tab');
                            parentElm.html(noDataHtml);

                        }
                        stopLoader();
                    });
                    if($rootScope.templateSuggestionPage){
                        angular.element(window).resize();
                    }
                }
        }

        function loadInvoiceContent(scope, url, element, templateId, showDocument) {
            if(!templateId){
                return
            }
            $(element).addClass("contractTemplateContent");
            url += templateId;
            var el = $(element);
            stopLoader();
            var isTemplate = false;
            startLoader();
            $http.get(addtStamp(url,true)).then(function (response) {
                if (_.has(response,'data.data') && response.data.data!= null && showDocument) {
                    contractTemplateService.renderDocHtmlView(element, scope, response.data.data, isTemplate, undefined, undefined, true);
                    stopLoader();
                }
                else {
                    var pages = 100; // Variable to be set for getting no. of pages on a request.
                    var noDataHtml;
                    if(response.data && response.data.error && showDocument) {
                        noDataHtml = "<div class='noTemplate'><div class=\"noDataToDisplay\"><div class=\"no-data-image\">  <video style='height: 115px;' id=\"docViewerNoData\"   muted=\"true\" preload=\"auto\" autoplay loop><source src=\"src/images/mp4/doc-viewer.mp4\"  type=\"video/mp4\"></video><span class=\"no-data-text\">"+response.data.error[0].message+"</span></div></div>";
                        el.find(".tabs").css("margin-top","0");
                        el.find("#tabs-inner-sec").addClass("no-template").append(noDataHtml);
                    }else {
                        noDataHtml = "<div class='noTemplate'><div class=\"noDataToDisplay\"><div class=\"no-data-image\">  <video style='height: 115px;' id=\"docViewerNoData\"   muted=\"true\" preload=\"auto\" autoplay loop><source src=\"src/images/mp4/doc-viewer.mp4\"  type=\"video/mp4\"></video><span class=\"no-data-text\"></span></div></div>";
                        scope.isInvoiceViewerActive = false;
                    }
                }
                stopLoader();
            })
        }

        function removeDynamicTableErrObj($scope){
            _.map($scope.modiFiedData.dynamicMetadata, function(val,key){
                if(val['values'] && val['values'] != ""){
                    if(val['values'].constructor == Array) {
                        _.forEach(val['values'], function (item) {
                            _.map(item, function (val, key) {
                                if (val && val['error']) {
                                    delete val['error']
                                }
                            })
                        })
                    }else if(typeof val['values'] == "object"){
                        if(val['values']['error']){
                            delete  val['values']['error'];
                        }
                    }
                }
            })
        }
        function scrollToErrorElem(scope,button){
            if(scope.fieldErrorLength > 0) {
                if (button == 'prev') {
                    if (scope.currentErrorElemIndex == 1) {
                        scope.currentErrorElemIndex = scope.fieldErrorLength;
                    } else {
                        scope.currentErrorElemIndex = scope.currentErrorElemIndex - 1;
                    }
                } else if (button == 'next') {
                    if (scope.currentErrorElemIndex == scope.fieldErrorLength) {
                        scope.currentErrorElemIndex = 1;
                    } else {
                        scope.currentErrorElemIndex = scope.currentErrorElemIndex + 1;
                    }
                }
                scope.toggleAllGroupsVal = false;
                scope.toggleAllGroups();
                const index = scope.currentErrorElemIndex > 0 ?scope.currentErrorElemIndex - 1 : scope.currentErrorElemIndex;
                const elem = angular.element(".dynamic-form").find(".errorClass:visible").eq(index);
                const form = angular.element(".jx-parentForm");
                if (elem.length > 0 && form.length > 0) {
                    const eleToScrollTo = (elem.hasClass("redirectButton")) ? elem : (elem.closest('label') || angular.element(elem[0].offsetParent.parentElement));
                    const eleScrollTop = eleToScrollTo.offset().top - form.offset().top + form.scrollTop();
                    form.animate({
                        scrollTop: eleScrollTop
                    }, 150, function () {
                        elem.focus();
                    });
                }
            }
            scope.errorBtnClick = false;
        }

        function changeErrorCount(totalErrorElem, currentElm, isWorkflowAction){
            let scope = this;
            const lengthToRemove = angular.element(".label-height .errorClass .errorClass").length;
            scope.fieldErrorLength = angular.element(".dynamic-form").find(".errorClass:visible").length - lengthToRemove;
            const fieldName = (currentElm && currentElm.attr('name'));
            if(fieldName && scope.errors && scope.errors.fieldErrors) {
                if (_.has(scope.errors.fieldErrors, [fieldName])) {
                    scope.errors.fieldErrors[fieldName].message = null;
                } else if (_.has(scope.errors.fieldErrors, 'dynamicMetadata.' + fieldName) || (scope.errors.fieldErrors.dynamicMetadata && scope.errors.fieldErrors.dynamicMetadata[fieldName])) {
                    scope.errors.fieldErrors['dynamicMetadata.' + fieldName].message = null;
                    if (scope.errors.fieldErrors.dynamicMetadata[fieldName])
                        scope.errors.fieldErrors.dynamicMetadata[fieldName].message = null;
                } else if (_.has(scope.errors.fieldErrors, 'stakeHolders.values.' + fieldName) || (scope.errors.fieldErrors.stakeHolders && scope.errors.fieldErrors.stakeHolders.values && scope.errors.fieldErrors.stakeHolders.values[fieldName]) ) {
                    scope.errors.fieldErrors['stakeHolders.values.' + fieldName].message = null;
                    if (scope.errors.fieldErrors.stakeHolders.values[fieldName])
                        scope.errors.fieldErrors.stakeHolders.values[fieldName].message = null;
                }
            }
            if(scope.fieldErrorLength < scope.currentErrorElemIndex && isWorkflowAction){
                scope.currentErrorElemIndex = scope.fieldErrorLength;
                totalErrorElem && currentElm && currentElm[0] && $(totalErrorElem).map((index, obj) =>
                    {
                        if( obj == currentElm[0] && index == scope.fieldErrorLength) {
                            this.scrollToErrorElem(scope,null);
                    }
                });
            }
            if(scope.fieldErrorLength && !angular.element(".fieldError-ribbon.active").length && isWorkflowAction){
                angular.element(".fieldError-ribbon").addClass("active");
                this.scrollToErrorElem(scope,null);
            }
        }
        function getsourceId(fieldData, data, url){
            var sourceIdField = fieldData.properties && fieldData.properties.sourceFieldId,
                dynamicFieldSource = fieldData.properties && fieldData.properties.dynamicFieldId;
            if(sourceIdField && dynamicFieldSource  && data && Object.entries(data).length != 0){
                var  sourceOptionId;
                angular.forEach(data, function(obj, i){
                    if((sourceIdField == obj.id) && obj.values && obj.values.id){
                        sourceOptionId = obj.values.id;
                    }
                });
                if(sourceOptionId && dynamicFieldSource){
                    url += "&sourceFieldId=" + sourceIdField + "&sourceFieldOptionId=" +  sourceOptionId + "&dynamicFieldId=" + dynamicFieldSource
                }
            }
            return url;
        }
        function activateTabOnLoad($scope) {
            let tabId = $scope.$route.current.params.activeTabId;
            let tabObj = $scope.layoutComponentFields.filter((tab, i)=>{
                if(tab.id == tabId){
                    return tab;
                }
            });
            tabObj = tabObj[0];
            // If tabId is valid then activate tab
            if(!!tabObj) {
                const isTabVisible = (angular.element('.jx-tabsUl .jx-leftTabs[data-mtab-id=' + tabId +']').length) ? true : false;
                if(isTabVisible){
                    const tabIdx = angular.element('.jx-tabsUl .jx-leftTabs[data-mtab-id=' + tabId +']').index();
                    $scope.showPage2DataTransformationService.returnObj.selectedTabObj = tabObj;
                    $scope.showPage2DataTransformationService.returnObj.selectedTabIndex = tabIdx;
                    if(tabObj.type == "contractClauseTab")
                        $scope.contractClauseTab.isVisible = true;
                    formService.alertMe(tabIdx, tabObj, null, $scope);
                } else{
                    angular.element('.jx-tabs > li[data-mtab-id=' + tabId +']').trigger('click');
                }
                privateMethods.removeParamFromUrl("activeTabId");
            } else{
                return;
            }
        }

        function deleteInvoiceCopy(url) {
            let scope = this;
            const args = {
                popupType: 'confirm',
                str: intl_msg[6436],
                heading: intl_msg[25772],
                yesCbFn: function(){
                    $http.delete(url).then(function (result) {
                        var showPageScope  = $(".content_container.showpage").scope();
                        $rootScope.isInvoiceViewerActive = false;
                        showPageScope.renderActionbuttons(showPageScope);
                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[6408], heading: intl_msg[24153]});
                        updateCommentAndFeeds.call(showPageScope);
                    });

                },
                noCbFn: function(){return false}
            }
            SirionUtils.openSirionDialogs(args);
        }

        function showInvoiceCopyToolTip(skipDelay){
            const invoiceToolTip = angular.element(".dataDescTip_Info.bounce_Me");
            invoiceToolTip.find(".inv-title").html($rootScope.invoiceName);
            const startTimer = skipDelay ? 0 : 2000;
            setTimeout(function () {
                showToolTip(invoiceToolTip, true);
                setTimeout(function () {
                    showToolTip(invoiceToolTip, false);
                }, 5000)
            }, startTimer)
        }

        function showToolTip(toolTip, show){
            (!show) ? toolTip.css("display", "none") : toolTip.css("display", "block");
        }

        function mapLayout(scope, fields) {
            fields.forEach(function(f){
                if(f.fields){
                    mapLayout(scope, f.fields);
                } else {
                    scope.aeFieldLabelMapper[f.name] = {
                        id              :   f.id,
                        label           :   f.label,
                        displayMode     :   f.displayMode,
                        isDynamicField  :   f.model=='dynamicMetadata'? true: false,
                        type            :   f.type,
                        isStakeHolder   :   f.model ? f.model.indexOf('stakeHolders')!=-1? true: false : false,

                    }
                }
            })
        }

        function prepareCompareModalData(resp) {
            let self = this;
            const versionsArr = _.values(resp.data.versions),
                totalVersions = versionsArr.length;

            if (!totalVersions) {
                console.error('No versions to Compare');
                return;
            }

            self.compareModeOnly = true;
            versionsArr.forEach(function (o) {
                o.documentFileId = o.id;
                if (o.version == versionsArr[totalVersions - 1].version) {
                    o.versionLabel = (intl_msg[29887] || "Current Clause") + " (" + (intl_msg[29890] || "Version") + " " + o.version + ")";
                } else {
                    o.versionLabel = (intl_msg[29886] || "Clause Version") + " " + o.version;
                }
            });

            self.compareData = _.orderBy(versionsArr, 'id');
            self.compareDocFileIds = {
                source: self.compareData[totalVersions - 2].documentFileId,
                compare: self.compareData[totalVersions - 1].documentFileId
            }
        }

        function openModalInCompareMode(){
            let self = this;
            self.compareModelInstance = $modal.open({
                templateUrl: self.createHtmlUrl("ui2.0/compareDocsModal.html"),
                modal: true,
                size: "lg",
                backdrop: "static",
                keyboard: false,
                scope: self,
                windowClass: "clonepopup"
            });

            self.compareModelInstance.result.then(function () {
                self.compareModeOnly = false;
                delete self.compareModelInstance;
            });

            self.closeCompareDocModal = function () {
                self.compareModelInstance.close();
            };
        }

        function loadCommPanelPreference() {
            const self = this,
                docTreeEntitiesArr = ['tblcontractdocuments', 'tblrelations', 'tblcontracts'],
                isShowpage = self.pageType=='show',
                isDocTreeVisibleOnPage = !self.mobileView && ( (docTreeEntitiesArr.indexOf(self.routeParams.entityName) > -1 ) || self.xmlTemp || self.createPageTree ) && !self.showPageFilters && !self.hideContractTree;

            if(self.isCommPanelOpened && !isDocTreeVisibleOnPage && isShowpage ){
                const togglePropsArr = ['expandLeftSection', 'doctreeFullSize;0', 'tabFullWidth;1', 'leftSecTransition'];
                togglePropsArr.forEach(prop => {
                    const props = prop.split(';');
                    self.togglePropValue( props[0], ( (props[1]) ? parseInt(props[1]) : props[1] ) );
                });
                self.commentDataScope = 1;
                self.timeLineFeedScope =-1
                self.timeLineFeedSecActive=false;
                $rootScope.$emit("update comment data scope",1)
            }

            if(!isShowpage) {
                // Caution need to check the impact of removing this for now commenting it
                // self.expandLeftSection = true;
            }
        }

        function showCommPanelNotification(jsonUrlOpts) {

            if(!jsonUrlOpts[3] || !jsonUrlOpts[2] || !urlToCodeMapper[jsonUrlOpts[2]]) {
                return;
            }

            const self = this,
                tStamp = new Date().getTime(),
                apiUrl = '/commentAttachments/count/' + urlToCodeMapper[jsonUrlOpts[2]] + "/" + jsonUrlOpts[3] + '?_t=' + tStamp,
                getCommentsCount = entityFactory.getJson(apiUrl, "GET");

            // Show comments notification on Communication Panel button
            getCommentsCount.success((response)=>{
                if(!!response.count || response.count == 0){
                    self.commentsCount = response.count;
                    self.showCommNotification = true;
                }else{
                    console.error('Application error from: ' + apiUrl);
                }
            }).error(function(error){
                window.systemWarning(error)
            })
        }

        function openInheritModal() {
            var self = this;
            self.inheritFileFieldObj.modalTitle = intl_msg[28082] ? intl_msg[28082] : 'Inherit File'
            self.inheritFileModal = $modal.open({
                template: '<document-transfer dirFor="inheritFile"></document-transfer>',
                modal: true,
                size: "lg",
                keyboard: false,
                backdrop: "static",
                windowClass: "inheritFileModal",
                scope: $(".communicationData").scope()
            });
        }

        function openMoveToTreeModal () {
            var self = this;
            self.moveToTreeFieldObj.modalTitle = intl_msg[28083] ? intl_msg[28083] : "Move to tree";
            self.moveToTreeModal = $modal.open({
                template: '<document-transfer dirFor="moveToTree"></document-transfer>',
                modal: true,
                size: "lg",
                keyboard: false,
                backdrop: "static",
                windowClass: "moveToTreeModal",
                scope: $(".communicationData").scope()
            });
        }

        function openSendToSigModal (fieldObj, calledFromContractDocument,reqId) {
            var sc = $(".communicationData").scope();
            sc.sendForSigFieldObj = {
                'id': 12425,
                'modalTitle': intl_msg[31579] || "Send For Signature"
            };
            var showPageId = sc.showpageData.id.values;
            var parentEntityId = sc.entityTypeId;
            sc.sendForSigFieldObj['fields'] = [];
            var fields = {
                'id': 12425,
                'name': "sendForSignature",
                'label': "sendForSignature",
                'type': "text",
                'layoutURL': "/listRenderer/list/436/defaultUserListMetaData/",
                'orderSeq': 100,
                'properties': {hideFieldFromView: true},
                'displayMode': "editable",
                'dataURL': "/listRenderer/list/436/tablistdata/" + parentEntityId + '/' + showPageId,
                'dynamicField': false,
                'autoComplete': false,
                'enableListView': false,
                'bulkEditable': false,
                'multiEntitySupport': false,
            };
            fieldObj = {
                'id': 12425,
                'modalTitle': intl_msg[31579] || "Send For Signature"
            };
            fieldObj['fields'] = fields
            sc.sendForSigFieldObj['fields'].push(fields);
            if (calledFromContractDocument) {
                sc.docuSigndocumentType = "DRAFT";
                sc.sendForSigFieldObj.fields[0].layoutURL = sc.sendForSigFieldObj.fields[0].layoutURL.replace("/436/", "/482/");
                sc.sendForSigFieldObj.fields[0].dataURL = sc.sendForSigFieldObj.fields[0].dataURL.replace("/436/", "/482/");
                $rootScope['calledFromContractDocument'] = true;
            } else {
                sc.docuSigndocumentType = "ATTACHMENT";
                sc.sendForSigFieldObj.fields[0].layoutURL = sc.sendForSigFieldObj.fields[0].layoutURL.replace("/482/", "/436/");
                sc.sendForSigFieldObj.fields[0].dataURL = sc.sendForSigFieldObj.fields[0].dataURL.replace("/482/", "/436/");
            }
            if (!sc.sendForSigFieldObj["modalTitle"]) {
                sc.sendForSigFieldObj["modalTitle"] = "";
            }
            sc.sendForSigFieldObj.properties = {};
            sc.sendForSigFieldObj.modalTitle = intl_msg[31579] || "Send For Signature";
            $rootScope.sendForSigFieldObj = sc.sendForSigFieldObj;
            var url = '/sendSignature/' + parentEntityId + '/' + showPageId;
            if ($rootScope['calledFromContractDocument']) {
                url = url + '?contractDocument=' + true;
            }
            window.location.hash = url;
        };

            function downloadCommentAttachmentData(payload) {
                const {entityId, entityTypeId} = payload;
                const url = addtStamp('/commentAttachments/download/entityType/' + entityTypeId + '/entity/' + entityId, true);

                $.ajax({
                    type: 'GET',
                    cache: false,
                    url: url,
                    contentType: "application/json",
                }).success((res) => {
                    if (res.success) {
                        Toaster.create(res.message);
                    } else {
                        const {errorList, message} = res;
                        if (errorList && errorList.length) {
                            Toaster.create(errorList[0].message, {iconClass:"icon-Information_filled"});
                        } else if (message) {
                            Toaster.create(message, {iconClass:"icon-Information_filled"});
                        }
                    }
                }).error((err) => {
                    const {responseJSON} = err;
                    if (responseJSON){
                        const {errorList} = responseJSON;
                        if (errorList && errorList.length) {
                            Toaster.create(errorList[0].message, {iconClass: "icon-Information_filled"});
                        }
                    }
                })
            }

            function downloadCommentData(payload) {
                let {tabMetaData, downloadObj, filterJson}=payload;
                var self = this;
                var cData = self.data;
                var commentListScope = self.commentListScope;
                var listId, entityTypeId, entityId, shortCodeId;
                if (tabMetaData && tabMetaData.id) {
                    listId = tabMetaData.id;
                }
                if (commentListScope && commentListScope.showpageData && commentListScope.showpageData.entityTypeId && commentListScope.showpageData.entityTypeId.values) {
                    entityTypeId = commentListScope.showpageData.entityTypeId.values;
                }
                if (commentListScope && commentListScope.showpageData && commentListScope.showpageData.id && commentListScope.showpageData.id.values) {
                    entityId = commentListScope.showpageData.id.values;
                }
                if (commentListScope && commentListScope.showpageData && commentListScope.showpageData.shortCodeId && commentListScope.showpageData.shortCodeId.values) {
                    shortCodeId = commentListScope.showpageData.shortCodeId.values;
                }

                if (downloadObj.id == 1147 || downloadObj.id == 1028) {
                    if (_.get(cData, "parentEntityTypeId.values")) {
                        entityTypeId = _.get(cData, "parentEntityTypeId.values")
                    }
                    if (_.get(cData, "parentShortCodeId.values.id")) {
                        entityId = _.get(cData, "parentShortCodeId.values.id");
                    }
                    if (_.get(cData, "parentShortCodeId.values.name")) {
                        shortCodeId = _.get(cData, "parentShortCodeId.values.name")
                    }
                }
                var fltrMap = {
                    "filterMap": {
                        "entityTypeId": null,
                        "offset": 0,
                        "size": 100,
                        "orderByColumnName": "id",
                        "orderDirection": "desc",
                        "filterJson": filterJson || {}
                    }
                };
                self.showToolsBox = false;
                formService.downloadShowData(fltrMap, listId, entityTypeId, entityId, shortCodeId);
            }


        function openSpecifiedTab(prop,scope) {
            var tab,tabExistInMainList = true;
            var idx = _.findIndex(scope.showPage2DataTransformationService.returnObj.leftTabInfo,function(o){
                return o.id == prop.tabId;
            });

            if(idx == -1) {
                idx = _.findIndex(scope.showPage2DataTransformationService.returnObj.allleftTabInfo,function(o){
                    return o.id == prop.tabId;
                });
                idx > -1 ? (tabExistInMainList = false) : null;
            }

            if(idx > -1) {
                if(tabExistInMainList) {
                    tab = scope.showPage2DataTransformationService.returnObj.leftTabInfo[idx];
                    scope.$broadcast('openDetailsTab', {'idx': idx, 'selectedTab': tab});
                }
                else {
                    tab = scope.showPage2DataTransformationService.returnObj.allleftTabInfo[idx];
                    scope.$broadcast('openDeatilsTabFromDD', {'idx': idx, 'selectedTab': tab});
                }
            }
        }

        function manageTimeLineCommentOldScope(olderScope,isCreateClone) {
                let that = this;
                that.isCreateClone = isCreateClone;
                if(isCreateClone) {
                    olderScope.feedsResponse = angular.copy(that.feedsResponse);
                    olderScope.timeLineFeedSecActive = angular.copy(that.timeLineFeedSecActive);
                    olderScope.commentDataScope = angular.copy(that.commentDataScope);
                    olderScope.hasTimeLineFeed = angular.copy(that.hasTimeLineFeed);
                    olderScope.timeLineFeedScope = angular.copy(that.timeLineFeedScope);
                    that.$$postDigest(function() {
                        if(that.timeLineFeedSecActive) {
                            that.setTimelineFeedDataScope(that.timeLineFeedScope);
                        }else if(that.commentDataScope && that.commentDataScope != -1) {
                            that.setCommDataScope(that.commentDataScope);
                        }
                    });
                }else if(!window.doNotApplyOldScope) {
                    that.feedsResponse = olderScope.feedsResponse;
                    that.hasTimeLineFeed = olderScope.hasTimeLineFeed;
                    that.timeLineFeedSecActive = olderScope.timeLineFeedSecActive;
                    that.timeLineFeedSecActiveCopy = olderScope.timeLineFeedSecActive;
                    that.commentDataScopeCopy = olderScope.commentDataScope;
                    that.timeLineFeedScopeCopy = olderScope.timeLineFeedScope;

                    if(that.expandLeftSection===false) {
                        that.$$postDigest(function() {
                            if(that.timeLineFeedSecActiveCopy) {
                                that.setTimelineFeedDataScope(that.timeLineFeedScopeCopy);
                            }
                            else if(that.commentDataScopeCopy && that.commentDataScopeCopy != -1) {
                                that.setCommDataScope(that.commentDataScopeCopy);
                            }
                        });
                    }
                }
                delete window.doNotApplyOldScope;
        }

        function loadContractToCdrTableData(contractId, requestType) {
            if(!contractId)
                return null
            return new Promise((resolve,reject) => {
                startLoader();
                var url = '/documentinfo/v1/getdocumentsdetails/' + contractId;
                if (requestType != null) {
                    url += '?requestType=' + requestType;
                }
                $http.get(addtStamp(url, true)).then(response => {
                    stopLoader();
                    resolve(response);
                })
            })
        }

        function getInsightFilters() {
            let cdRId = SirionUtils.getParameterValueFromURL(window.location.href,"cdrId");
            let updatedURL = "/insightfilter/get/160/"+ cdRId + "/" + listId;

            return $http.get(updatedURL);
        }

            function shouldGenerateDraft(entityTypeId, id) {
                startLoader();
                let apiUrl = `/generate/draft-doc/templateWizard/${entityTypeId.values}/${id}`;
                let postJson = {
                    "size": 20,
                    "offset": 0,
                    "lastBtnClick": false
                }
                return $http.post(apiUrl, postJson);
            }


        // Bulk update Attendance in GB
        function bulkAttendanceUpdateGB(scope, that, listService) {
            scope.shouldCheck = true;
            scope.showHideField = function (value, id) {
                scope.shouldCheck = true;
                var bulkAttandanceID = scope.bulkEditAttandanceLayout.filter((layout)=>{
                    if(layout.queryName == 'attended'){
                        return layout
                    }
                })[0]["id"];
                if(value == 'true') {
                    scope.attendanceSubmit = value = true;

                } else {
                    scope.attendanceSubmit = value = false;
                }
                if(id == bulkAttandanceID) {
                    scope.bulkEditAttandanceLayout.map((l,i)=> {
                        if(l.id != bulkAttandanceID) {
                            l.shouldShow = value;
                            l.selected.name = null;
                            scope.shouldCheck = value;
                            if(value) {
                                scope.shouldCheck = value;
                            }
                        }
                    });
                    if(!scope.$$phase) {
                        scope.$apply();
                    }
                } else  {

                }
            };

            var listData = scope.actualAoData.data;
            var temLayout1 = [] , temLayout2  = [];
            scope.bulkEditAttandanceLayout.map((l,i)=> {
                scope.attendanceSubmit = true;
                var displayFormat = JSON.parse(l.displayFormat);
                if (displayFormat && displayFormat.optionValues) {
                    l.optionValues = displayFormat.optionValues;
                    l.selected = {};
                }
                if (l.queryName == "attended") {
                    l.shouldShow = true;
                    temLayout1.push(l);
                } else {
                    l.shouldShow = false;
                    temLayout2.push(l);
                }
            });
            scope.bulkEditAttandanceLayout = temLayout1.concat(temLayout2);

            scope.mapTrueFalse = function (value) {
                if(value == "true") {
                    return "Yes"
                } else if (value == "false") {
                    return "No"
                } else {
                    return value
                }
            };
            
            scope.bulkEditAttendanceModalClose = () => {
                (scope.bulkEditAttandanceLayout || []).forEach(l => l.error = false);
                scope.bulkAttendanceValueError = false;
                scope.bulkEditAttendenceInstance.close();
            };

            scope.bulkEditAttendenceInstance = $modal.open({
                templateUrl: $rootScope.createHtmlUrl("bulkEditAttendencePopup.html"),
                size: "375px",
                backdrop: "static",
                keyboard: false,
                modalFade: true,
                windowClass: "bulk_edit_attendence clonepopup",
                scope: scope,
            });

            scope.submitEditBulkAttendence = function () {
                var postData = {
                    "governanceBodyChildParticipants": []
                };
                scope.bulkAttendanceValueError = false;
                // we need to terminate the loop only when attended is not present
                let terminateMap=false
                scope.bulkEditAttandanceLayout.map((l,i)=> {
                    if(!terminateMap){
                        if(!l.selected.name && l.queryName === "attended" && scope.shouldCheck) {
                                l.error = scope.bulkAttendanceValueError = true;
                                terminateMap=true;
                        } else {
                            l.error = false;
                            if(l.queryName == "attended") {
                                postData.meetingAttended = l.selected.name;
                            } else if (l.queryName == "presencetype"){
                                postData.presenceType = l.selected.name || "";
                            } else{
                                const durationEle = $(`#show-duration-${l.fieldId}`)[0];
                                //durationEle will not present in DOM when user select atttende as "no"
                                if (durationEle) {
                                    const duration = durationEle.getAttribute('data-value');
                                    postData[l.queryName] = duration;
                                } else {
                                    postData[l.queryName] = "";
                                }
                            }
                        }
                    }
                });
                if(!scope.$$phase){
                    scope.$apply();
                }
                if (!scope.bulkAttendanceValueError || !scope.shouldCheck) {
                    //var obj = scope.attendanceUpdateGlobal(scope.selectedCheckBoxes, scope.metaData, postData);
                    var obj = that.attendanceUpdateGlobal(scope, scope.selectedCheckBoxes, scope.metaData);
                    if(obj.attendanceJson && obj.attendanceJson.length) {
                        obj.attendanceJson.map(function (eachAtt) {
                            if (scope.selectedCheckBoxes.indexOf(eachAtt.currentCheckbox)>-1) {
                                eachAtt.duration = postData.duration;
                                eachAtt.presenceType = postData.presenceType;
                                eachAtt.meetingAttended = postData.meetingAttended;
                                delete eachAtt.currentCheckbox;
                                delete eachAtt.attendent;
                                postData.governanceBodyChildParticipants.push(eachAtt);
                            }
                        });
                    } else {
                        return
                    }

                    var urlPost = '/tblgovernancebodychild/updateBulkGCBParticipantsAttendance/'+ scope.data.id.values;
                    window.startLoader();
                    $http({
                        data: JSON.stringify(postData),
                        dataType: "json",
                        method: 'POST',
                        url: urlPost
                    }).then(function (res) {
                        scope.dataTable.fnDraw();
                        if(res && res.data && res.data.message){
                            Toaster.create(intl_msg[7062]);
                            setTimeout(function () {
                                scope.deselectAllSelections();
                                scope.bulkeditAttendence =false;
                                //scope.documentPostSuccess = false;
                                scope.dataTable.fnDraw();

                            }, 3000);
                        } else if (res && res.data && res.data.errorMessage){
                            scope.attendencePostError = res.data.error
                            Toaster.create(res.data.errorMessage);
                        }
                        // since we need to enable both button irrespective of api call status
                        $('#btnbulkEditAttendence').removeClass('disableEdit');
                        $('#btnAddExternalUser').removeClass('disableEdit');

                        let checkboxIndex = listService.checkboxColumnIndex(scope);
                        scope.bulkeditAttendence = false;
                        scope.bulkEditAttendenceInstance.close();
                        scope.deselectAllSelections();
                        scope.dataTable.fnSetColumnVis(checkboxIndex,false,false);
                        scope.bulkDocumentDownloadApplicable = false;
                    });
                }

            };

        }
            function fetchFeedsData($scope){
                if($scope.feedsResponse && $scope.feedsResponse.isCommentBoxAllowed) {
                    let entityId = $scope.data.id.values,
                        entityTypeId = $scope.data.entityTypeId.values;
                        getFeedsData.call($scope, {entityId,entityTypeId}).then(res => {
                        if(res && res.status == 200 && !res.data.ERROR) {
                            let sc = $scope;
                            sc.feedsResponse = res.data.DATA;
                            sc.feedsResponse.entityTypeId = entityTypeId;
                            sc.feedsResponse.entityId = entityId;
                            window.sarc.channelBroadcast("timelineFeeds",{
                                actionType:'feedsResponseUpdate',
                                value: sc.feedsResponse
                            },'timelineFeedsSubscription')
                        }
                    })
                }
            }

            function setPreviewTab(isActive,$scope){
            $scope.previewTab.isActive = !!isActive;
        }

            function toggleExpectedLanguage($scope) {
                startLoader();
                const mountAt = "#expectedLanguageModal";
                let languageUrl = addtStamp("/metadataautoextraction/project-languages?projectId="+$scope.data.id.values,true);
                $http.get(languageUrl).then(function(res){
                    stopLoader();
                    if(res.data.responseCode == '200' && !_.isEmpty(res.data.response)) {
                        let languageData = res.data.response;
                        let sortedLanguages = languageData.sort((a, b) => (b.selected - a.selected));

                        let propsToPass = {
                            languages: sortedLanguages,
                            projectId: $scope.data.id.values,
                            projectName: $scope.data.name.values
                        };
                        window.reactComponents.mountDynamicComponent(mountAt, "ExpectedLanguageModal", propsToPass);
                    } else {
                        Toaster.create('Some error occurred',{iconClass:"icon-Information_filled"});
                    }
                })
            }

        function handleRedirectionFromShortCodeId (val, action, newVal, cb) {
            val = val ? val.toUpperCase() : val;
            const regex = /^([a-zA-Z]{2,4})([0-9]+)$/;
            let valid = true, res, type;
            res = regex.exec(val);
            if (res != null) {
                type = res[1].toUpperCase();
                if (!window.CodeToURLPartMapping[type]) {
                    valid = false;
                }
            } else {
                valid = false;
            }
            if (!valid || res[2] > 2147483647) {
                window.Toaster.create(intl_msg[5055] || "Please enter a valid Sirion ID.",{iconClass:"icon-Information_filled"});
                SirionUtils.redirectFromShortCodeIdToListing();
                return;
            }
            type = type.toUpperCase();
            let id = res[2];
            let inactiveString = "?am=true";
            if(isNaN(id)) return;
            let url = window.appName + "/" + window.CodeToURLPartMapping[type] + "/getEntityId/" + id + inactiveString;
            if (type == "FO") {
                url = url + "&entityTypeId=76";
            }
            if (type == "CO") {
                url = url + "&entityTypeId=61";
            }
            let errRedirection = false;
            $http.get(url).then(function (response) {
                let notificationText = '';
                if (response.data) {
                    if (response.data == 0) {
                        notificationText = intl_msg[5056] || "Please enter an individual tier or select View all to view corresponding data.";
                        errRedirection = true;
                    } else {
                        if (window.CodeToURLPartMapping[type] != null) {
                            let _url;
                            if(type == "AE"){
                                _url = "#/autoExtraction/document/" + response.data;
                            } else {
                                _url = `#/${action ? action : 'show'}/${window.CodeToURLPartMapping[type]}/${response.data}`;
                            }
                            window.location.replace(_url);
                            newVal && cb(newVal);
                        }
                        else {
                            notificationText = intl_msg[5055] || "Please enter a valid Sirion ID.";
                            errRedirection = true;
                        }
                    }
                } else {
                    notificationText = intl_msg[6419] || "Either you do not have the required permissions or this Entity has been deleted or doesn't exist anymore.";
                    errRedirection = true;
                }
                if(notificationText != '')
                    window.Toaster.create(notificationText,{iconClass:"icon-Information_filled"});
                if(errRedirection)
                    SirionUtils.redirectFromShortCodeIdToListing()
            })
        }

        // Fetch templates for create SubDD

        function fetchTemplateCreateSubDD (e, $scope) {
            let templateUrl;
            const createLinksFieldsLabels = $scope.createLink.length > 0 && $scope.createLink.map(field => field.label);
            const currentFieldIndex = createLinksFieldsLabels.findIndex(label => label == e.target.innerHTML);
            const currentField = $scope.createLink[currentFieldIndex];

            if(!!currentField?.templateListApi && !$scope.createLink[currentFieldIndex].isFetched) {
                templateUrl = currentField["templateListApi"];
                $scope.createLink[currentFieldIndex].isTemplateDownloadInProgress = true;
                $http({
                    url: appName + templateUrl,
                    dataType: 'json',
                    method: 'GET'
                }).then(function successCallback(response) {
                    $scope.createLink[currentFieldIndex].isTemplateDownloadInProgress = false;
                    $scope.arrFromMyObj = response.data;
                    $scope.createLink[currentFieldIndex].isFetched = true;
                    $scope.createFieldsObjTemplate[e.target.innerHTML] = Object.keys($scope.arrFromMyObj).map(function(key) {
                        return $scope.arrFromMyObj[key];
                    });
                    var templatesList = Object.keys($scope.arrFromMyObj).map(function(key) {
                        return $scope.arrFromMyObj[key];
                    });
                    var createFields = $scope.createLink[currentFieldIndex].fields;
                    var _fieldIndex = createFields.findIndex(function(field) {
                        return field.bulkSystemLabel === "Bulk";
                    });
                    if (_fieldIndex < 0) {
                        _fieldIndex = createFields.findIndex(function(field) {
                            return field.label && field.label.toLowerCase() === "bulk";
                        });
                    }
                    if (_fieldIndex >= 0) {
                        createFields[_fieldIndex].templates = templatesList;
                    }
                    showOpenCreateSubDD(e);
                }).catch(() => {
                    $scope.createLink[currentFieldIndex].isTemplateDownloadInProgress = false;
                    $scope.createLink[currentFieldIndex].isFetched = true;
                    showOpenCreateSubDD(e);
                });
            }
            if(!$scope.createLink[currentFieldIndex]?.isTemplateDownloadInProgress) {
                if (angular.element(e.currentTarget).find('.jx-createLinkAnchor').hasClass('active')) {
                    angular.element(e.currentTarget).find('.jx-create-subDD').slideUp();
                    angular.element(e.currentTarget).find('.jx-createLinkAnchor').removeClass('active');
                } else {
                    showOpenCreateSubDD(e);
                }
            }
        }

        function showOpenCreateSubDD (e) {
            angular.element('#jx-createBtn').find('.jx-create-subDD').slideUp();
            angular.element('#jx-createBtn').find('.jx-createLinkAnchor').removeClass('active');
            angular.element(e.currentTarget).find('.jx-create-subDD:not(.sLevel)').slideDown();
            angular.element(e.currentTarget).find('.jx-createLinkAnchor:not(.sLevel-anchor)').addClass('active');
        }

        function highlightCoordinatesInIFrame (args) {
            const {iframeElement,coordinates,pagenum,id,uiCalculatedPageDimensions} = args;
            if(iframeElement) {
                iframeElement.adjustAutoScroll(pagenum);
                if (!coordinates)
                    return
                var cos = typeof coordinates == 'string' ? JSON.parse(coordinates) : coordinates;
                cos = iframeElement.coordinatesConverter(cos, true); // Uncomment it for pdfJs story
                var highLight = {
                    highLightId: id,
                    containers: [],
                    autoScrollOff: !!uiCalculatedPageDimensions
                }
                if (cos.length) {
                    cos.forEach(function (co) {
                        if (co.PageWidth && co.PageHeight) {
                            highLight.containers.push({
                                pageno: co.pageNumber,
                                top: (co.y / co.PageHeight) * 100,
                                left: 2,
                                height: (co.h / co.PageHeight) * 100,
                                width: 96
                            })
                        }
                    })
                }
                if (highLight.containers.length) {
                    iframeElement.entityHighLightFromAE(highLight, pagenum);
                }
            }
        }
        function getUrlOpts() {
            let path = window.location.hash;
            if(path.indexOf("_t") > -1){
                path = path.split("_t")[0];
            }
            return path.split("/");
        }

        function getSurveyQueryParams(isSupplierSurvey, isBulkSurvey) {
            const type = $rootScope?.relationId ? 'show' : 'list';
            const id = $rootScope?.relationId? $rootScope.relationId : window.listId;
            const jsonUrl = window.location.href;
            const jsonUrlOpts = getUrlOpts();
            let typeId = null;
            if(jsonUrl.indexOf("/show/") > -1) {
                typeId = urlToCodeMapper[jsonUrlOpts[2]];
            } else {
                typeId = window.listJson.entityTypeId;
            }
            return `type=${type}&id=${id}&supplier=${isSupplierSurvey}&bulk=${isBulkSurvey}&typeId=${typeId}`;
        }
        
        function getContractDownloadPermission(scope,parentEntityId,entityId) {
            const docUrl = `/tblcontractdocuments/documentmetadata/${parentEntityId}/${entityId}`;
            $http.get(docUrl).then(response => {
                const hasDownload = !!response?.data?.download;
                scope.fromContract = window.pdfJsPermissionFlags.hasDownloadBtn = hasDownload;
            })
            .catch(error => {
                scope.fromContract = false;
                window.pdfJsPermissionFlags.hasDownloadBtn = false;
            });
        };

    }]);
//******************************* End of showPageService **************************************//

})();

/**** create entity popup function copied from layout.js *****/
function loadDialogBox2(urlp, listPage, title, api, bulkedit, closeCallBack) {
    checkId = {};
    startLoader();

    if (listPage == "true") {
        $('#showdialog_list').html("");
    } else {
        $('#showdialog').html("");
    }

    var promise = $.ajax({
        type: 'GET',
        cache: false,
        dataType: "html",
        url: urlp,
        success: function (response, status) {
            stopLoader();
            if (typeof $("#data-ng-app").scope != "undefined") {
                var sc = $("#data-ng-app").scope();
                if (sc.integrationLayer) {
                    window.directAjax = true;
                }
            }
            if (api) {
                jsonApi = api;
                if (window.directAjax) {
                    response = $(response).find("#contentWrap");
                } else {
                    response = $(response).find(".showPage");
                }
            }
            if (listPage == "true") {
                $('#showdialog_list').html(response);
                $("#showdialog_list #xmlTemp").hide();
                if (api && (api.indexOf("/bulkaction/") > -1 || api.indexOf("/commentAttachments/bulkUpload/") > -1)) {
                    $("#showdialog_list").dialog("option", "width", 630);
                    $("#showdialog_list").dialog("option", "height", "auto");
                    $("#showdialog_list").dialog("option", "resizable", false);
                    $("#showdialog_list").addClass("commentBox");
                    $("#showdialog_list").dialog('option', 'title', 'Comments and Attachments');
                } else {
                    $("#showdialog_list").removeClass("commentBox");
                    $("#showdialog_list").dialog("option", "resizable", true);
                }
                $("#showdialog_list").dialog("open");
                if ($("#showdialog_list").find("input").length > 0)
                    $("#showdialog_list").find("input").eq(0).focus();
                //start code to compile popup in angularjs -- added by pushpendra
                if (bulkedit) {
                    $("#showdialog_list").find("form").addClass("searchPage");
                }
                if (typeof angular != "undefined") {
                    var scope = angular.element($("#data-ng-app")).scope();
                    $('#showdialog_list').off("dialogclose");
                    $('#showdialog_list').on("dialogclose", function () {

                        var tableId = $("#cr");
                        if (tableId.length > 0) {
                            if (typeof BU !== "undefined" && BU.setSelectAllActive) { BU.setSelectAllActive(false); } else { isSelectAll = false; }
                            $("#checkallupdate").prop("checked", false);
                            checkedVal = [];
                            tableId.dataTable().fnDraw();

                        }

                        $(".showPage").eq(1).fadeOut("slow");
                        //$(".showPage").hide();
                        scope.closePopupFlag();

                        if ($(".showPage").size() > 1) {
                            $(".showPage:last").remove();
                        }

                        setTimeout(function () {
                            //$(".ui-dialog").remove();
                            scope.$root.myJson = {};
                            scope.initializeListPage();
                            if (!scope.$$phase) {
                                scope.$apply();
                            }
                            scope.applyBasePageJson();
                            $("#mainContainer .dataTables_wrapper > .dataTables_filter, #mainContainer  .dataTables_wrapper > .dataTables_length, #mainContainer  .dataTables_wrapper > .dataTables_info, #mainContainer  .dataTables_wrapper > .dataTables_paginate").remove();
                            $(".showPage").fadeIn("slow");

                        }, 10);
                        $('#showdialog_list').html("");
                    });
                    var response1 = scope.compilePopupHtml("#showdialog_list", bulkedit);
                    var sc = angular.element($("#data-ng-app")).scope();
                    //sc.layoutData.externalEmailAllowed=true;
                    if (title && (title.toLowerCase() == "create email" || title.toLowerCase() == "create mass email") && sc && sc.layoutData && sc.layoutData.headerBar && sc.layoutData.headerBar.externalEmailAllowed) {
                        setTimeout(function () {
                            $('div.externalEmailsField').show();
                        }, 100);
                    } else {
                        setTimeout(function () {
                            $('div.externalEmailsField').hide();
                        }, 100);
                    }

                    if (sc.layoutData.headerBar.maxEmailIdsAllowed)
                        maxEmailIdCount = parseInt(sc.layoutData.headerBar.maxEmailIdsAllowed);
                }
                //end code to compile popup in angularjs -- added by pushpendra
            } else {
                if (!directAjax) {
                    var splitHtml = response.split("\n");
                    splitHtml.shift();
                    splitHtml.shift();
                    response = splitHtml.join("\n");
                }
                /***temporary hack for open create dialog ****/
                response = response.replace(/dynamic-form/g, 'dynamic-form-new');
                if(urlp.indexOf('tblcompositerating/')>-1){
                    response = response.replace(/tblcompositerating\/updateManual/g, 'tblcompositerating\/updateManual?baseUrl=ux');
                }
                $('#showdialog').html(response);

                if( !$('#showdialog').dialog("instance") ){
                    $("#showdialog").dialog({
                        autoOpen: true,
                        open:true,
                        height: $(window).height() - 50,
                        width: $(window).width() - 50,
                        open:()=>{
                            resetDialogPosition(this);
                            if (title) {
                                $('div[aria-describedby=\'showdialog_list\'] .ui-dialog-title, div[aria-describedby=\'showdialog\'] .ui-dialog-title').html(title);
                            }
                        }
                    });
                }else {
                    $("#showdialog").dialog("open");
                }
                if ($("#showdialog").find("input[type='text']").length > 0)
                    $("#showdialog").find("input[type='text']")[0].focus();
                //start code to compile popup in angularjs -- added by pushpendra
                if (typeof angular != "undefined") {
                    var scope = angular.element($("#ngViewID")).scope();
                    document.createElement('dynamicFormNew');
                    document.createElement('dynamic-form-new');
                    $('#showdialog').off("dialogclose");
                    $('#showdialog').on("dialogclose", function () {
                        $(".showPage").eq(1).fadeOut("slow");
                        //$(".showPage").hide();
                        scope.closePopupFlag();
                        if ($(".showPage").size() > 1) {
                            $(".showPage:last").remove();
                        }
                        setTimeout(function () {
                            //$(".ui-dialog").remove();
                            scope.applyBasePageJson(closeCallBack);
                            $("#mainContainer .dataTables_wrapper > .dataTables_filter, #mainContainer  .dataTables_wrapper > .dataTables_length, #mainContainer  .dataTables_wrapper > .dataTables_info, #mainContainer  .dataTables_wrapper > .dataTables_paginate").remove();
                            $(".showPage").fadeIn("slow");
                        }, 10);
                    });
                    if(urlp.indexOf('tblcompositerating/')== -1  && urlp.indexOf("masterdeliverycountrys")== -1) {
                        scope.compilePopupHtml("#showdialog");
                    }
                }
                //console.log("m :L",scope.currentOuterPopup);
                //end code to compile popup in angularjs -- added by pushpendra
            }

        },
        error: function (jqXHR, textStatus, errorThrown) {
            stopLoader();
            if (jqXHR.status == 704) {
                SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[5057], heading: intl_msg[24153]});
            } else if (jqXHR.status == 801) {
                SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[6423], heading: intl_msg[24153]});
            } else
                handleErrorResponse(jqXHR);
        }
    });

    /*  setTimeout(function() {
        loadTable();
        var oTable = $('div.dataTables_scrollBody>table.display');
        if (oTable.length > 0) {
          oTable.dataTable().fnAdjustColumnSizing();

          $("div.dataTables_scrollBody>table.display").width($(".dataTables_scrollHeadInner").width() - 2);
        }
      }, 500);*/
    if (title) {
        $('div[aria-describedby=\'showdialog_list\'] .ui-dialog-title, div[aria-describedby=\'showdialog\'] .ui-dialog-title').html(title);
    }
    return promise;
}

const responseHandler = function (response,customMessage = '',closePopUp) {
    if(response.data.success){
        Toaster.create(_.get(response,"data.response.message") || customMessage);
        closePopUp && closePopUp();
    }else if (_.get(response,"data.header.response.status") == "applicationError") {
        let message = _.get(response,"data.header.response.errorMessage") || "Something went wrong";
        SirionUtils.openSirionDialogs({popupType: 'alert', str: "Something went wrong", heading: intl_msg[24153]});
    }else if (_.get(response,'errorMessages.length')) {
        let arr = response.errorMessages;
        if(arr.length == 1){
            htmlError+=arr[0]["errorMessage"];
        }else{
            for(var i = 0;i<arr.length;i++){
                htmlError+="<p><span>"+(i+1)+". </span><span>"+arr[i]["errorMessage"]+"</span></p>";
            }
        }
        SirionUtils.openSirionDialogs({popupType: 'alert', str: htmlError, heading: intl_msg[24153]});
    }
}

const removeUnusedGroupInfo = function(prefilledGroupData,isAEProjectShowPage){
    return prefilledGroupData.map((group) => {
        if(!isAEProjectShowPage){
            if(group.selectAll){
                return {
                    "selectAll":group.selectAll,
                    "groupId":group.groupId
                }
            } else {
                return {
                    "groupId": group.groupId,
                    "categoryIds": group.categoryIds,
                    "fieldIds": group.fieldIds
                }
            }
        } else {
            return {
                "groupId": group.groupId,
                "categoryIds": group.categoryIds,
                "fieldIds": group.fieldIds,
                "fields": group.fields,
                "categories": group.categories,
                "group": group.group
            }
        }
    })
};

const openLinkClauseModal = function(propsToPass){
    let mountAt = '#link_clause_modal';
    var counter = 0;
    var interval = setInterval(()=>{
        if($(mountAt).length) {
            clearInterval(interval);
            if (!$(mountAt).children().length){
                window.reactComponents.mountDynamicComponent(mountAt, "LanguageVariations", propsToPass);
                window.sarc.channelBroadcast("LinkClause", {
                    actionType: 'OpenLinkClauseModal',
                    clauseCategory: propsToPass.clauseCategory,
                    clauseId : propsToPass.clauseId
                }, 'linkClauseSubscription')
            }
        }
    },10)
}

/*
    return valid tabs mapperand supported icon classes for different tags
*/
const getIconAndValidTabsMapper = function(){
    const validSignatureTabs = ["signHereTabs", "companyTabs", "dateSignedTabs", "emailAddressTabs", "fullNameTabs", "initialHereTabs", "textTabs", "titleTabs"];
    const signatureTabToIconMap = {
        'signHereTabs' : {name: "Signature",icon : 'icon-Initiate-Signature'},
        'companyTabs' : {name: "Company",icon : 'icon-Company'},
        'dateSignedTabs' :{name: "Date Signed",icon : 'icon-calendar'},
        'emailAddressTabs':{name: "Email",icon : 'icon-Mass-Mails'},
        'fullNameTabs':{name: "Name",icon : 'icon-Profile'},
        'initialHereTabs':{name: "Initial",icon : 'icon-Initials'},
        'textTabs':{name: "Text",icon : 'icon-Text_Box'},
        'titleTabs':{name: "Title",icon : 'icon-Title'}
    };
    return {signatureTabToIconMap,validSignatureTabs};
}



